


// import React, { useState, useEffect } from 'react';
// import { Search, Wallet, AlertCircle, History, X, Loader2, Printer, CheckCircle } from 'lucide-react';

// export default function FeeManagement() {
//   const sessionUser = JSON.parse(sessionStorage.getItem('userSession')) || { name: "Admin Accounts" };

//   const [activeTab, setActiveTab] = useState('ledger'); // ledger, pending, history
//   const [feeData, setFeeData] = useState([]);
//   const [receiptsLog, setReceiptsLog] = useState([]);
//   const [searchTerm, setSearchTerm] = useState('');
//   const [tableLoading, setTableLoading] = useState(false);

//   // Modal Popups Open & Configuration Flags
//   const [isCollectModalOpen, setIsCollectModalOpen] = useState(false);
//   const [isPrintModalOpen, setIsPrintModalOpen] = useState(false);
  
//   const [selectedStudent, setSelectedStudent] = useState(null);
//   const [selectedReceipt, setSelectedReceipt] = useState(null);

//   const [courseCascades, setCourseCascades] = useState([]);

// const [paymentForm, setPaymentForm] = useState({ 
//   target_course: '', 
//   fee_type: 'Semester Fee', 
//   academic_term: 'Semester 1', 
//   amount_paid_now: '', 
//   payment_mode: 'Online Transfer', 
//   transaction_reference: '' 
// });

// // ➕ ADDED: Pagination Control Parameters
//   const [currentPage, setCurrentPage] = useState(1);
//   const itemsPerPage = 5;

//   const administrativeTabs = [
//     { id: 'ledger', name: 'Collect Fees Ledger', icon: Wallet },
//     { id: 'pending', name: 'Track Pending Installments', icon: AlertCircle },
//     { id: 'history', name: 'Payment Receipts History', icon: History }
//   ];


//   useEffect(() => {
//   const fetchCascades = async () => {
//     try {
//       const res = await fetch('https://metapi.emedhatechnologies.com/api/academic-updates/course-cascades');
//       const result = await res.json();
//       if (result.success) {
//         setCourseCascades(result.data || []);
//       }
//     } catch (err) {
//       console.error("Failed to load course cascades:", err);
//     }
//   };
//   fetchCascades();
// }, []);



// // Helper to find the matched course configuration from cascades
// const getSelectedCourseInfo = (courseName) => {
//   if (!courseName) return null;
//   return courseCascades.find(
//     (c) => c.course_name.trim().toLowerCase() === courseName.trim().toLowerCase()
//   ) || null;
// };



//   useEffect(() => {
//     if (activeTab === 'history') {
//       fetchReceiptsLog();
//     } else {
//       fetchFeeSummaries();
//     }
//   }, [activeTab, searchTerm]);

//   const fetchFeeSummaries = async () => {
//     setTableLoading(true);
//     try {
//       const res = await fetch(`https://metapi.emedhatechnologies.com/api/fees?activeTab=${activeTab}&search=${encodeURIComponent(searchTerm)}`);
//       const result = await res.json();
//       if (result.success) setFeeData(result.data);
//     } catch (err) { console.error(err); }
//     finally { setTableLoading(false); }
//   };

//   const fetchReceiptsLog = async () => {
//     setTableLoading(true);
//     try {
//       const res = await fetch('https://metapi.emedhatechnologies.com/api/fees/receipts-history');
//       const result = await res.json();
//       if (result.success) setReceiptsLog(result.data);
//     } catch (err) { console.error(err); }
//     finally { setTableLoading(false); }
//   };

// const handleOpenCollectFees = (student) => {
//   const computedBalanceDue = Number(student.pending_balance_due) > 0 
//     ? student.pending_balance_due 
//     : (Number(student.total_agreed_fees) - Number(student.total_paid_amount)) || 0;

//   setSelectedStudent({
//     ...student,
//     pending_balance_due: computedBalanceDue
//   });

//   const studentCourses = student.target_course 
//     ? student.target_course.split(',').map(c => c.trim()) 
//     : ['General Course'];

//   const initialCourse = studentCourses[0];
//   const courseInfo = getSelectedCourseInfo(initialCourse);
//   const isNonSemester = courseInfo?.structure_type === 'Non-Semester';

//   // Extract first available term label (e.g. 'Semester 1' or 'Year 1')
//   const defaultTerm = courseInfo?.semester_details?.[0]?.term_label 
//     || (isNonSemester ? 'Year 1' : 'Semester 1');

//   setPaymentForm({ 
//     target_course: initialCourse, 
//     fee_type: isNonSemester ? 'Yearly Fee' : 'Semester Fee', 
//     academic_term: defaultTerm, 
//     amount_paid_now: '', 
//     payment_mode: 'Online Transfer', 
//     transaction_reference: '' 
//   });

//   setIsCollectModalOpen(true);
// };

// const handleSendReceiptWhatsApp = (receipt) => {
//   if (!receipt) return;

//   // 1. Format mobile number (91XXXXXXXXXX)
//   let rawMobile = String(receipt.mobile || '').replace(/\D/g, '');
//   if (rawMobile.length === 10) {
//     rawMobile = '91' + rawMobile;
//   }

//   // 2. Format receipt date
//   const receiptDate = receipt.payment_date 
//     ? new Date(receipt.payment_date).toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: 'numeric' }) 
//     : new Date().toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: 'numeric' });

//   // 3. Draft formatted WhatsApp receipt
//   const messageBody = 
// `🧾 *Official Fee Receipt Voucher - MET Academy*

// Dear *${receipt.name}*,

// Here is your official fee transaction voucher:

// 🧾 *Receipt No:* ${receipt.receipt_number}
// 📋 *Admission No:* ${receipt.adm_number}
// 🎓 *Course:* ${receipt.target_course}
// 📅 *Academic Term:* ${receipt.academic_term}
// 🏢 *Campus / Center:* ${receipt.college_university || 'Main Campus'}
// 💰 *Amount Received:* ₹${Number(receipt.amount_paid_now).toLocaleString('en-IN')}.00
// 💳 *Payment Mode:* ${receipt.payment_mode}
// 🔢 *Txn / Reference ID:* ${receipt.transaction_reference || 'N/A'}
// 📅 *Date of Payment:* ${receiptDate}

// This is a computer-generated voucher issued by the MET Academy Finance Portal.

// For any queries, please contact the MET Academy accounts desk.

// Warm Regards,
// *MET Academy Accounts Department*`;

//   // 4. Open WhatsApp Web / App directly
//   if (rawMobile && rawMobile.length >= 10) {
//     const waUrl = `https://api.whatsapp.com/send?phone=${rawMobile}&text=${encodeURIComponent(messageBody)}`;
//     const link = document.createElement('a');
//     link.href = waUrl;
//     link.target = '_blank';
//     link.rel = 'noopener noreferrer';
//     document.body.appendChild(link);
//     link.click();
//     document.body.removeChild(link);
//   } else {
//     alert("Warning: Student mobile number is missing or invalid for this receipt.");
//   }
// };

// const handleCourseChangeInModal = (newCourse) => {
//   const courseInfo = getSelectedCourseInfo(newCourse);
//   const isNonSemester = courseInfo?.structure_type === 'Non-Semester';
//   const defaultTerm = courseInfo?.semester_details?.[0]?.term_label 
//     || (isNonSemester ? 'Year 1' : 'Semester 1');

//   setPaymentForm((prev) => ({
//     ...prev,
//     target_course: newCourse,
//     fee_type: isNonSemester ? 'Yearly Fee' : 'Semester Fee',
//     academic_term: defaultTerm
//   }));
// };

//   // const handleCollectFeesSubmit = async (e) => {
//   //   e.preventDefault();
//   //   try {
//   //     const res = await fetch('https://metapi.emedhatechnologies.com/api/fees/collect-payment', {
//   //       method: 'POST',
//   //       headers: { 'Content-Type': 'application/json' },
//   //       body: JSON.stringify({ student_id: selectedStudent.student_id, ...paymentForm, sessionUser })
//   //     });
//   //     if ((await res.json()).success) {
//   //       setIsCollectModalOpen(false);
//   //       fetchFeeSummaries();
//   //     }
//   //   } catch (err) { console.error(err); }
//   // };

// const handleCollectFeesSubmit = async (e) => {
//   e.preventDefault();

//   try {
//     // 1. Map frontend state directly to what your existing backend requires
//     const selectedCourse = paymentForm.target_course || selectedStudent?.target_course || 'Academic Program';
//     const selectedTerm = paymentForm.academic_term || paymentForm.term_label || selectedStudent?.current_semester || 'Semester 1';
//     const amountPaid = paymentForm.amount_paid_now || paymentForm.paid_amount || paymentForm.amount || 0;
//     const paymentMode = paymentForm.payment_mode || paymentForm.payment_method || 'Online / Cash';
//     const txnRef = paymentForm.transaction_reference || paymentForm.transaction_id || `TXN-${Date.now().toString().slice(-6)}`;
//     const feeType = paymentForm.fee_type || 'Tuition / Semester Fee';

//     const payload = {
//       student_id: selectedStudent?.student_id || selectedStudent?.id,
//       target_course: selectedCourse,
//       fee_type: feeType,
//       academic_term: selectedTerm,
//       amount_paid_now: amountPaid,
//       payment_mode: paymentMode,
//       transaction_reference: txnRef,
//       sessionUser: sessionUser || { id: 1, name: "Accounts Staff" }
//     };

//     // 2. Call your existing backend endpoint
//     const res = await fetch('https://metapi.emedhatechnologies.com/api/fees/collect-payment', {
//       method: 'POST',
//       headers: { 'Content-Type': 'application/json' },
//       body: JSON.stringify(payload)
//     });

//     const result = await res.json();

//     if (result.success) {
//       // 3. Format student phone number (91XXXXXXXXXX)
//       let rawMobile = String(selectedStudent?.mobile || '').replace(/\D/g, '');
//       if (rawMobile.length === 10) {
//         rawMobile = '91' + rawMobile;
//       }

//       // 4. Construct receipt details
//       const receiptNo = `MET-REC-${Date.now()}`;
//       const studentAdmNo = selectedStudent?.adm_number || selectedStudent?.roll_number || `MET-ADM-${selectedStudent?.id || selectedStudent?.student_id}`;
//       const paymentDate = paymentForm.payment_date || new Date().toISOString().substring(0, 10);

//       // 5. Draft formatted WhatsApp receipt
//       const messageBody = 
// `💳 *Fee Payment Acknowledgment - MET Academy*

// Dear *${selectedStudent?.name}*,

// Thank you for your payment! We have successfully received your fee installment. Here are your transaction details:


// 📋 *Admission No:* ${studentAdmNo}
// 🎓 *Course:* ${selectedCourse}
// 📅 *Term / Semester:* ${selectedTerm}
// 🏷️ *Fee Type:* ${feeType}
// 💰 *Amount Paid:* ₹${Number(amountPaid).toLocaleString('en-IN')}
// 💳 *Payment Mode:* ${paymentMode}
// 🔢 *Txn / Reference ID:* ${txnRef}
// 📅 *Payment Date:* ${paymentDate}

// Your payment has been officially recorded and updated in your student account.

// For any queries regarding your fee receipt or ledger balance, please contact the MET Academy accounts desk.

// Warm Regards,
// *MET Academy Accounts Department*`;

//       // 6. Trigger WhatsApp Web tab
//       if (rawMobile && rawMobile.length >= 10) {
//         const waUrl = `https://api.whatsapp.com/send?phone=${rawMobile}&text=${encodeURIComponent(messageBody)}`;
        
//         const link = document.createElement('a');
//         link.href = waUrl;
//         link.target = '_blank';
//         link.rel = 'noopener noreferrer';
//         document.body.appendChild(link);
//         link.click();
//         document.body.removeChild(link);
//       } else {
//         console.warn("Student mobile number is missing or invalid. WhatsApp skipped.");
//       }

//       // 7. Close modal and refresh records
//       setIsCollectModalOpen(false);
//       if (typeof fetchFeeSummaries === 'function') {
//         fetchFeeSummaries();
//       }
//       alert(`Payment of ₹${Number(amountPaid).toLocaleString('en-IN')} recorded successfully!`);
//     } else {
//       alert("Failed to collect payment: " + (result.message || "Unknown server error"));
//     }
//   } catch (err) {
//     console.error("Fee payment processing error:", err);
//     alert("Network error while recording fee payment.");
//   }
// };


//   const triggerPrintReceipt = (receipt) => {
//     setSelectedReceipt(receipt);
//     setIsPrintModalOpen(true);
//   };


//   // ➕ ADDED: Pagination Slicing Matrix Computation
//   const indexOfLastItem = currentPage * itemsPerPage;
//   const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  
//   // Conditionally target the active data array depending on the selected workspace tab view mode
//   const currentActiveData = activeTab === 'history' ? receiptsLog : feeData;
//   const currentItems = currentActiveData.slice(indexOfFirstItem, indexOfLastItem);
//   const totalPages = Math.ceil(currentActiveData.length / itemsPerPage);

//   return (
//     <div>
//       {/* STEP 1: TOP NAVIGATION MENU TABS */}
//       <div style={styles.topActionBar}>
//         <div style={styles.tabScrollGroup}>
//          {/* Update your administrativeTabs mapping inside the JSX return */}
// {administrativeTabs.map((tab) => {
//   const Icon = tab.icon;
//   return (
//     <button 
//       key={tab.id} 
//       onClick={() => { 
//         setActiveTab(tab.id); 
//         setSearchTerm(''); 
//         setCurrentPage(1); // ➕ ADDED: Reset back to page 1
//       }} 
//       style={{ ...styles.tabBtn, ...(activeTab === tab.id ? styles.tabBtnActive : {}) }}
//     >
//       <Icon size={15} style={{ marginRight: '6px' }} /> {tab.name}
//     </button>
//   );
// })}
//         </div>
//       </div>

//       {/* STEP 2: SEARCH FILTER BAR CONTROLS */}
//       <div style={styles.filterControlPanel}>
//         <div style={styles.searchWrapper}>
//           <Search size={16} style={styles.searchIcon} />
//        {/* Update your input tag change rule */}
// <input 
//   type="text" 
//   placeholder="Search by student name, roll number..." 
//   value={searchTerm} 
//   onChange={(e) => { 
//     setSearchTerm(e.target.value); 
//     setCurrentPage(1); // ➕ ADDED: Reset page counter on keystroke
//   }} 
//   style={styles.tableSearchInput} 
// />
//         </div>
//         <div style={styles.totalIndicator}>Active Entries Count: <strong style={{ color: '#459bf2' }}>{activeTab === 'history' ? receiptsLog.length : feeData.length}</strong></div>
//       </div>

//       {/* STEP 3: DATA LEDGER VIEWS GRID */}
//       {tableLoading ? (
//         <div style={{ display: 'flex', justifyContent: 'center', padding: '40px' }}><Loader2 size={32} style={{ animation: 'spin 1s linear infinite' }} color="#459bf2" /></div>
//       ) : (
//         <div style={{ overflowX: 'auto', width: '100%' }}>
//           {activeTab !== 'history' ? (
//             <table style={styles.dataTable}>
//               <thead>
//                 <tr>
//                   <th style={styles.tableTh}>Admission No.</th>
//                   <th style={styles.tableTh}>Student Details</th>
//                   <th style={styles.tableTh}>Enrolled Course</th>
//                   <th style={styles.tableTh}>Campus Location</th>
//                   <th style={styles.tableTh}>Total Agreed Fees</th>
//                   <th style={styles.tableTh}>Total Paid Amount</th>
//                   <th style={styles.tableTh}>Pending Balance Due</th>
//                   <th style={styles.tableTh}>Actions</th>
//                 </tr>
//               </thead>
//               <tbody>
//                 {currentItems.map((item) => (
//                   <tr key={item.id} style={styles.tableTr}>
//                    {/* Change item.roll_number to item.adm_number inside your table mapping loop */}
// <td style={{ ...styles.tableTd, fontWeight: '700' }}>{item.adm_number}</td>
//                     <td style={styles.tableTd}><strong>{item.name}</strong><br/><small style={{ color: '#64748b' }}>{item.mobile}</small></td>
//                     <td style={styles.tableTd}><span style={styles.courseBadge}>{item.target_course}</span></td>
//                     <td style={styles.tableTd}>{item.college_university}</td>
//                     <td style={{ ...styles.tableTd, fontWeight: '600', color: '#0f172a' }}>₹{Number(item.total_agreed_fees).toLocaleString('en-IN')}</td>
//                     <td style={{ ...styles.tableTd, fontWeight: '600', color: '#10b981' }}>₹{Number(item.total_paid_amount).toLocaleString('en-IN')}</td>
                  
                  
                  
//                  {/* Pending Balance Cell */}
// <td style={{ ...styles.tableTd, fontWeight: '700', color: Number(item.pending_balance_due) > 0 || Number(item.total_agreed_fees) === 0 ? '#e30504' : '#15803d' }}>
//   {Number(item.total_agreed_fees) === 0 ? (
//     <span style={{ color: '#d97706' }}>Unset / Pending Setup</span>
//   ) : Number(item.pending_balance_due) > 0 ? (
//     `₹${Number(item.pending_balance_due).toLocaleString('en-IN')}`
//   ) : (
//     'Fully Paid ✓'
//   )}
// </td>

// {/* Action Button Cell */}
// <td style={styles.tableTd}>
//   {Number(item.pending_balance_due) > 0 || Number(item.total_agreed_fees) === 0 ? (
//     <button onClick={() => handleOpenCollectFees(item)} style={styles.collectBtn}>Collect Fees</button>
//   ) : (
//     <span style={styles.completedTag}>Complete</span>
//   )}
// </td>
//                   </tr>
//                 ))}
//               </tbody>
//             </table>
//           ) : (
//             <table style={styles.dataTable}>
//               <thead>
//                 <tr>
//                   <th style={styles.tableTh}>Receipt Number</th>
//                   <th style={styles.tableTh}>Admission No.</th>
//                   <th style={styles.tableTh}>Student Name</th>
//                   <th style={styles.tableTh}>Assigned Course</th>
//                   <th style={styles.tableTh}>Academic Term</th>
//                   <th style={styles.tableTh}>Payment Mode</th>
//                   <th style={styles.tableTh}>Amount Paid</th>
//                   <th style={styles.tableTh}>Receipt print</th>
//                 </tr>
//               </thead>
//               <tbody>
//                 {currentItems.map((rec) => (
//                   <tr key={rec.id} style={styles.tableTr}>
//                     <td style={{ ...styles.tableTd, fontWeight: '600' }}>{rec.receipt_number}</td>
//                     <td style={styles.tableTd}>{rec.adm_number}</td>
//                     <td style={styles.tableTd}><strong>{rec.name}</strong></td>
//                     <td style={styles.tableTd}>{rec.target_course}</td>
//                     <td style={styles.tableTd}><span style={styles.termLabel}>{rec.academic_term}</span></td>
//                     <td style={styles.tableTd}>{rec.payment_mode}</td>
//                     <td style={{ ...styles.tableTd, fontWeight: '700', color: '#10b981' }}>₹{Number(rec.amount_paid_now).toLocaleString('en-IN')}</td>
//                     <td style={styles.tableTd}>
//                       <button onClick={() => triggerPrintReceipt(rec)} style={styles.printActionBtn}><Printer size={13} /> Print Voucher</button>
//                     </td>
//                   </tr>
//                 ))}
//               </tbody>
//             </table>
//           )}
//         </div>
//       )}


//       {/* ➕ ADDED: PAGINATION BAR CONTROLS */}
//       {currentActiveData.length > 0 && (
//         <div style={styles.paginationDock}>
//           <button 
//             disabled={currentPage === 1} 
//             onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))}
//             style={currentPage === 1 ? { ...styles.pageBtn, ...styles.pageBtnDisabled } : styles.pageBtn}
//           >
//             Previous
//           </button>
//           <span style={styles.pageIndicator}>
//             Page <strong>{currentPage}</strong> of {totalPages || 1}
//           </span>
//           <button 
//             disabled={currentPage === totalPages || totalPages === 0} 
//             onClick={() => setCurrentPage(prev => Math.min(prev + 1, totalPages))}
//             style={currentPage === totalPages || totalPages === 0 ? { ...styles.pageBtn, ...styles.pageBtnDisabled } : styles.pageBtn}
//           >
//             Next
//           </button>
//         </div>
//       )}

//       {/* MODAL 1: RECORD AND COLLECT LIVE PAYMENT TRANSACTION */}
//   {/* RECORD FEE PAYMENT MODAL */}
// {isCollectModalOpen && (
//   <div style={styles.modalBackdrop}>
//     <div style={styles.modalWrapperCard}>
//       <div style={styles.modalHeader}>
//         <h3 style={{ margin: 0, fontSize: '15px' }}>Record Live Student Fee Payment</h3>
//         <button onClick={() => setIsCollectModalOpen(false)} style={styles.modalCloseX}><X size={18} /></button>
//       </div>
//       <form onSubmit={handleCollectFeesSubmit} style={styles.modalForm}>
//       <div style={{ padding: '8px 12px', background: '#f8fafc', borderRadius: '8px', border: '1px solid #e2e8f0' }}>
//   <small style={{ color: '#64748b', fontSize: '11px', textTransform: 'uppercase' }}>Selected Candidate</small>
//   <div style={{ fontSize: '14px', fontWeight: '700', color: '#334155' }}>
//     {selectedStudent?.name} ({selectedStudent?.adm_number})
//   </div>
//   <div style={{ fontSize: '12px', color: '#e30504', fontWeight: '600', marginTop: '2px' }}>
//     {Number(selectedStudent?.total_agreed_fees) === 0 ? (
//       <span style={{ color: '#d97706' }}>Initial Deposit / Registration Payment</span>
//     ) : (
//       `Remaining Outstanding Fees Due: ₹${Number(selectedStudent?.pending_balance_due).toLocaleString('en-IN')}`
//     )}
//   </div>
// </div>

//         {/* 1. COURSE SELECTION */}
// <div style={styles.fieldContainer}>
//   <label style={styles.fieldLabel}>Select Enrolled Course</label>
//   <select 
//     value={paymentForm.target_course} 
//     onChange={(e) => handleCourseChangeInModal(e.target.value)} 
//     style={styles.formSelect}
//   >
//     {selectedStudent?.target_course?.split(',').map((cStr, idx) => (
//       <option key={idx} value={cStr.trim()}>{cStr.trim()}</option>
//     ))}
//   </select>
// </div>


//         {/* 2. FEE TYPE & SEMESTER TERM SELECTORS */}
//         {/* <div style={styles.formSplitGrid}>
//           <div style={styles.fieldContainer}>
//             <label style={styles.fieldLabel}>Fee Category Type</label>
//             <select 
//               value={paymentForm.fee_type} 
//               onChange={(e) => setPaymentForm({ ...paymentForm, fee_type: e.target.value })} 
//               style={styles.formSelect}
//             >
//               <option value="Semester Fee">Semester Fee</option>
//               <option value="Exam Fee">Semester Exam Fee</option>
//               <option value="Admission Deposit">Admission Deposit</option>
//             </select>
//           </div>

//           <div style={styles.fieldContainer}>
//             <label style={styles.fieldLabel}>Academic Term / Semester</label>
//             <select 
//               value={paymentForm.academic_term} 
//               onChange={(e) => setPaymentForm({ ...paymentForm, academic_term: e.target.value })} 
//               style={styles.formSelect}
//             >
//               {paymentForm.fee_type === 'Exam Fee' ? (
//                 <>
//                   <option value="Semester Exam Fee 1">Semester Exam Fee 1</option>
//                   <option value="Semester Exam Fee 2">Semester Exam Fee 2</option>
//                   <option value="Semester Exam Fee 3">Semester Exam Fee 3</option>
//                   <option value="Semester Exam Fee 4">Semester Exam Fee 4</option>
//                   <option value="Semester Exam Fee 5">Semester Exam Fee 5</option>
//                   <option value="Semester Exam Fee 6">Semester Exam Fee 6</option>
//                 </>
//               ) : (
//                 <>
//                   <option value="Admission Deposit">Admission Deposit</option>
//                   <option value="Semester 1 Fees">Semester 1 Fees</option>
//                   <option value="Semester 2 Fees">Semester 2 Fees</option>
//                   <option value="Semester 3 Fees">Semester 3 Fees</option>
//                   <option value="Semester 4 Fees">Semester 4 Fees</option>
//                   <option value="Semester 5 Fees">Semester 5 Fees</option>
//                   <option value="Semester 6 Fees">Semester 6 Fees</option>
//                 </>
//               )}
//             </select>
//           </div>
//         </div> */}


//         {(() => {
//   const courseInfo = getSelectedCourseInfo(paymentForm.target_course);
//   const isNonSemester = courseInfo?.structure_type === 'Non-Semester';
  
//   // Get available terms from semester_details or generate based on duration
//   const availableTerms = courseInfo?.semester_details?.length > 0 
//     ? courseInfo.semester_details.map(d => d.term_label)
//     : (isNonSemester 
//         ? Array.from({ length: courseInfo?.minimum_duration || 1 }, (_, i) => `Year ${i + 1}`)
//         : Array.from({ length: (courseInfo?.minimum_duration || 3) * 2 }, (_, i) => `Semester ${i + 1}`)
//       );

//   return (
//     <div style={styles.formSplitGrid}>
//       {/* Fee Category Type */}
//       <div style={styles.fieldContainer}>
//         <label style={styles.fieldLabel}>Fee Category Type</label>
//         <select 
//           value={paymentForm.fee_type} 
//           onChange={(e) => {
//             const newType = e.target.value;
//             setPaymentForm(prev => ({
//               ...prev,
//               fee_type: newType,
//               academic_term: availableTerms[0] || (isNonSemester ? 'Year 1' : 'Semester 1')
//             }));
//           }} 
//           style={styles.formSelect}
//         >
//           {isNonSemester ? (
//             <>
//               <option value="Yearly Fee">Yearly Tuition Fee</option>
//               <option value="Exam Fee">Yearly Exam Fee</option>
//               <option value="Admission Deposit">Admission Deposit</option>
//             </>
//           ) : (
//             <>
//               <option value="Semester Fee">Semester Tuition Fee</option>
//               <option value="Exam Fee">Semester Exam Fee</option>
//               <option value="Admission Deposit">Admission Deposit</option>
//             </>
//           )}
//         </select>
//       </div>

//       {/* Academic Term Selector */}
//       <div style={styles.fieldContainer}>
//         <label style={styles.fieldLabel}>
//           {isNonSemester ? 'Academic Year / Term' : 'Academic Term / Semester'}
//         </label>
//         <select 
//           value={paymentForm.academic_term} 
//           onChange={(e) => setPaymentForm({ ...paymentForm, academic_term: e.target.value })} 
//           style={styles.formSelect}
//         >
//           {paymentForm.fee_type === 'Admission Deposit' ? (
//             <option value="Admission Deposit">Admission Deposit</option>
//           ) : (
//             availableTerms.map((term, idx) => (
//               <option key={idx} value={term}>
//                 {term} {paymentForm.fee_type === 'Exam Fee' ? 'Exam Fee' : 'Fees'}
//               </option>
//             ))
//           )}
//         </select>
//       </div>
//     </div>
//   );
// })()}

//         {/* 3. AMOUNT & PAYMENT MODE */}
//         <div style={styles.formSplitGrid}>
//           {/* Replace the current Amount Paid input JSX block with this: */}
// <div style={styles.fieldContainer}>
//   <label style={styles.fieldLabel}>Amount Paid Now (₹)</label>
//   <input 
//     type="number" 
//     required 
//     min="1" 
//     max={
//       Number(selectedStudent?.pending_balance_due) > 0 
//         ? selectedStudent?.pending_balance_due 
//         : Number(selectedStudent?.total_agreed_fees) > 0 
//           ? selectedStudent?.total_agreed_fees 
//           : 999999
//     } 
//     placeholder="Enter paid amount" 
//     value={paymentForm.amount_paid_now} 
//     onChange={(e) => setPaymentForm({ ...paymentForm, amount_paid_now: e.target.value })} 
//     style={styles.formInput} 
//   />
// </div>

//           <div style={styles.fieldContainer}>
//             <label style={styles.fieldLabel}>Payment Collection Mode</label>
//             <select 
//               value={paymentForm.payment_mode} 
//               onChange={(e) => setPaymentForm({ ...paymentForm, payment_mode: e.target.value })} 
//               style={styles.formSelect}
//             >
//               <option>Online Transfer</option>
//               <option>Cash Desk Counter</option>
//             </select>
//           </div>
//         </div>

//         {/* 4. TRANSACTION REFERENCE */}
//         <div style={styles.fieldContainer}>
//           <label style={styles.fieldLabel}>Transaction Reference / UTR Number</label>
//           <input 
//             type="text" 
//             required 
//             placeholder="e.g. UTR Hash or Voucher ID" 
//             value={paymentForm.transaction_reference} 
//             onChange={(e) => setPaymentForm({ ...paymentForm, transaction_reference: e.target.value })} 
//             style={styles.formInput} 
//           />
//         </div>

//         <div style={styles.formActionDock}>
//           <button type="button" onClick={() => setIsCollectModalOpen(false)} style={styles.formCancelBtn}>Cancel</button>
//           <button type="submit" style={styles.formSaveBtn}>Confirm & Log Payment</button>
//         </div>
//       </form>
//     </div>
//   </div>
// )}
      
// {/* MODAL 2: HIGH-END PRINTABLE VOUCHER RECEIPT */}
// {isPrintModalOpen && (
//   <div style={styles.modalBackdrop}>
//     <div style={{ ...styles.modalWrapperCard, maxWidth: '680px', background: '#ffffff', padding: '0', borderRadius: '16px', overflow: 'hidden' }}>
      
//       {/* Premium Top Bar Window Control */}
//       <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '16px 24px', background: '#0f172a', color: '#ffffff' }}>
//         <h3 style={{ margin: 0, fontSize: '14px', fontWeight: '600', letterSpacing: '0.5px' }}>TRANSACTION VOUCHER PREVIEW</h3>
//         <button onClick={() => setIsPrintModalOpen(false)} style={styles.modalCloseX}><X size={18} color="#94a3b8" /></button>
//       </div>
      
//       {/* Scrollable Preview Workspace */}
//       <div style={{ overflowY: 'auto', padding: '24px', maxHeight: '65vh', background: '#f8fafc' }}>
        
//         {/* START OF LUXURIOUS PRINTABLE RECEIPT CHASSIS */}
//         <div id="receipt-print-area" style={styles.receiptChassis}>
          
//           {/* Top Brand Identity Header Banner */}
//           <div style={styles.receiptHeader}>
//             <div style={styles.receiptLogoBox}>MET</div>
//             <div style={{ flex: 1 }}>
//               <h2 style={styles.receiptInstitutionTitle}>MET ACADEMY OF HIGHER EDUCATION</h2>
//               <p style={styles.receiptInstitutionSub}>{selectedReceipt?.college_university || 'Main Campus Center'}</p>
//             </div>
//             <div style={{ textAlign: 'right' }}>
//               <span style={styles.receiptDocumentLabel}>FEE RECEIPT</span>
//             </div>
//           </div>

//           {/* Structured Two-Column Metadata Matrix */}
//           <div style={styles.receiptMetaGrid}>
//             <div style={styles.metaColumn}>
//               <div style={styles.metaRow}><span style={styles.metaLabel}>Receipt Number</span> <strong style={styles.metaValue}>{selectedReceipt?.receipt_number}</strong></div>
//               <div style={styles.metaRow}><span style={styles.metaLabel}>Admission No</span> <strong style={styles.metaValue}>{selectedReceipt?.adm_number}</strong></div>
//               <div style={styles.metaRow}><span style={styles.metaLabel}>Student Name</span> <strong style={{ ...styles.metaValue, textTransform: 'uppercase', color: '#0f172a' }}>{selectedReceipt?.name}</strong></div>
//             </div>
//             <div style={{ ...styles.metaColumn, borderLeft: '1px solid #e2e8f0', paddingLeft: '20px' }}>
//               <div style={styles.metaRow}><span style={styles.metaLabel}>Payment Date</span> <strong style={styles.metaValue}>{selectedReceipt?.payment_date ? new Date(selectedReceipt.payment_date).toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: 'numeric' }) : 'N/A'}</strong></div>
//               <div style={styles.metaRow}><span style={styles.metaLabel}>Course Track</span> <strong style={styles.metaValue}>{selectedReceipt?.target_course}</strong></div>
//               <div style={styles.metaRow}><span style={styles.metaLabel}>Academic Phase</span> <strong style={{ ...styles.metaValue, color: '#1c6ec9' }}>{selectedReceipt?.academic_term}</strong></div>
//             </div>
//           </div>

//           {/* Minimal Stark Particulars Accounting Ledger Table */}
//           <table style={styles.receiptTable}>
//             <thead>
//               <tr>
//                 <th style={{ ...styles.receiptTh, width: '60px', textAlign: 'center' }}>S.No</th>
//                 <th style={styles.receiptTh}>Particulars / Fee Breakdown Description</th>
//                 <th style={{ ...styles.receiptTh, textAlign: 'right', width: '150px' }}>Amount</th>
//               </tr>
//             </thead>
//             <tbody>
//               <tr>
//                 <td style={{ ...styles.receiptTd, textAlign: 'center', color: '#64748b' }}>01</td>
//                 <td style={styles.receiptTd}>
//                   <div style={{ fontWeight: '600', color: '#1e293b' }}>{selectedReceipt?.academic_term} Allocation</div>
//                   <div style={{ fontSize: '11px', color: '#64748b', marginTop: '4px' }}>
//                     Mode: {selectedReceipt?.payment_mode} | Ref: <span style={{ fontFamily: 'monospace' }}>{selectedReceipt?.transaction_reference}</span>
//                   </div>
//                 </td>
//                 <td style={{ ...styles.receiptTd, textAlign: 'right', fontWeight: '700', color: '#0f172a', fontSize: '14px' }}>
//                   ₹{Number(selectedReceipt?.amount_paid_now).toLocaleString('en-IN')}.00
//                 </td>
//               </tr>
//               {/* Aesthetic Padding Row to Emulate Professional Printed Forms */}
//               <tr>
//                 <td style={styles.receiptTdEmpty}></td>
//                 <td style={styles.receiptTdEmpty}></td>
//                 <td style={styles.receiptTdEmpty}></td>
//               </tr>
//               {/* Grand Total Summary Row Block */}
//               <tr>
//                 <td colSpan="2" style={styles.receiptTotalLabelCell}>Total Fees Received</td>
//                 <td style={styles.receiptTotalValueCell}>
//                   ₹{Number(selectedReceipt?.amount_paid_now).toLocaleString('en-IN')}.00
//                 </td>
//               </tr>
//             </tbody>
//           </table>

//           {/* Validation & Signature Authority Area */}
//           <div style={styles.receiptFooterSignatures}>
//             <div style={styles.signatureBox}>
//               <div style={styles.signatureLine}></div>
//               <span>Depositor Signature</span>
//             </div>
//             <div style={styles.signatureBox}>
//               <div style={styles.signatureLine}></div>
//               <span>Authorized Officer / Cashier</span>
//             </div>
//           </div>

//           <div style={styles.receiptDisclaimer}>
//             This is an official computer-generated statement issued by the MET Academy Finance Portal. Valid without a physical ink stamp.
//           </div>

//         </div>
//         {/* END OF LUXURIOUS PRINTABLE RECEIPT CHASSIS */}

//       </div>

//       {/* Modal Actions Footer Bar Drawer */}
//       <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '12px', padding: '16px 24px', background: '#ffffff', borderTop: '1px solid #e2e8f0' }}>
//         <button onClick={() => setIsPrintModalOpen(false)} style={styles.formCancelBtn}>Cancel</button>
//        {/* <button 
//     type="button"
//     onClick={() => handleSendReceiptWhatsApp(selectedReceipt)} 
//     style={{ 
//       display: 'inline-flex', 
//       alignItems: 'center', 
//       gap: '6px', 
//       background: '#10b981', 
//       color: '#ffffff', 
//       border: 'none', 
//       padding: '9px 16px', 
//       borderRadius: '8px', 
//       fontWeight: '600', 
//       fontSize: '13px', 
//       cursor: 'pointer' 
//     }}
//   >
//     📲 Send WhatsApp
//   </button> */}
       
//         <button 
//           onClick={() => {
//             const printContent = document.getElementById('receipt-print-area').innerHTML;
//             const originalContent = document.body.innerHTML;
//             document.body.innerHTML = printContent;
//             window.print();
//             window.location.reload();
//           }} 
//           style={styles.receiptPrintSubmitBtn}
//         >
//           <Printer size={14} /> Print Formal Receipt
//         </button>
//       </div>
//     </div>
//   </div>
// )}
//     </div>
//   );
// }

// // FORCE PACKING LUXURIOUS CONTROLS ARCHITECTURE SHEET LAYOUT
// const styles = {
//   topActionBar: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: '16px', marginBottom: '20px', flexWrap: 'wrap' },
//   tabScrollGroup: { display: 'flex', gap: '8px', overflowX: 'auto', paddingBottom: '4px' },
//   tabBtn: { display: 'inline-flex', alignItems: 'center', padding: '10px 16px', background: '#ffffff', border: '1px solid #e2e8f0', borderRadius: '10px', color: '#64748b', fontSize: '13.5px', fontWeight: '500', cursor: 'pointer', whiteSpace: 'nowrap', transition: 'all 0.2s' },
//   tabBtnActive: { background: 'linear-gradient(135deg, #459bf2 0%, #1c6ec9 100%)', borderColor: '#459bf2', color: '#ffffff', boxShadow: '0 4px 12px rgba(69, 155, 242, 0.15)' },
//   filterControlPanel: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: '16px', marginBottom: '16px', flexWrap: 'wrap', borderBottom: '1px solid #edf2f7', paddingBottom: '14px' },
//   searchWrapper: { position: 'relative', display: 'flex', alignItems: 'center', flex: 1, maxWidth: '300px', width: '100%' },
//   searchIcon: { position: 'absolute', left: '12px', color: '#94a3b8' },
//   tableSearchInput: { width: '100%', padding: '9px 12px 9px 36px', background: '#f8fafc', border: '1px solid #e2e8f0', borderRadius: '9px', color: '#0f172a', fontSize: '13.5px', outline: 'none' },
//   totalIndicator: { fontSize: '14.5px', fontWeight: '600', color: '#334155' },
//   dataTable: { width: '100%', borderCollapse: 'collapse', textAlign: 'left' },
//   tableTh: { padding: '12px 14px', borderBottom: '2px solid #e2e8f0', color: '#64748b', fontSize: '11px', textTransform: 'uppercase', letterSpacing: '0.5px', fontWeight: '600', whiteSpace: 'nowrap' },
//   tableTr: { borderBottom: '1px solid #f1f5f9', background: '#ffffff' },
//   tableTd: { padding: '12px 14px', color: '#475569', fontSize: '13px', verticalAlign: 'middle', whiteSpace: 'nowrap' },
//   courseBadge: { background: '#eff6ff', border: '1px solid #bfdbfe', color: '#1e40af', padding: '4px 8px', borderRadius: '6px', fontSize: '11.5px', fontWeight: '500', display: 'inline-block' },
//   termLabel: { background: '#f1f5f9', color: '#334155', padding: '4px 6px', borderRadius: '5px', fontSize: '11px', fontWeight: '600', border: '1px solid #e2e8f0' },
//   completedTag: { color: '#15803d', background: '#dcfce7', padding: '4px 10px', borderRadius: '6px', fontSize: '12px', fontWeight: '700' },
//   collectBtn: { background: '#ffffff', border: '1px solid #cbd5e1', color: '#1c6ec9', padding: '5px 12px', borderRadius: '6px', fontSize: '12px', fontWeight: '700', cursor: 'pointer', transition: 'all 0.2s' },
//   printActionBtn: { background: '#f8fafc', border: '1px solid #cbd5e1', color: '#334155', padding: '5px 10px', borderRadius: '6px', fontSize: '12px', fontWeight: '600', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '4px' },
//   modalBackdrop: { position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(15, 23, 42, 0.25)', backdropFilter: 'blur(8px)', zIndex: 2000, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '20px' },
//   modalWrapperCard: { background: '#ffffff', border: '1px solid rgba(255,255,255,0.8)', borderRadius: '20px', width: '100%', maxWidth: '560px', maxHeight: '85vh', padding: '24px', display: 'flex', flexDirection: 'column', boxSizing: 'border-box', boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.05)' },
//   modalHeader: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', paddingBottom: '12px', borderBottom: '1px solid #e2e8f0' },
//   modalCloseX: { background: 'transparent', border: 'none', color: '#94a3b8', cursor: 'pointer' },
//   modalForm: { display: 'flex', flexDirection: 'column', gap: '14px', marginTop: '14px' },
//   formSplitGrid: { display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px' },
//   fieldContainer: { display: 'flex', flexDirection: 'column', gap: '4px' },
//   fieldLabel: { color: '#64748b', fontSize: '11px', fontWeight: '600', textTransform: 'uppercase', letterSpacing: '0.5px' },
//   formInput: { width: '100%', padding: '10px 12px', background: '#f8fafc', border: '1px solid #e2e8f0', borderRadius: '8px', color: '#0f172a', fontSize: '13px', outline: 'none', boxSizing: 'border-box' },
//   formSelect: { padding: '10px 12px', background: '#f8fafc', border: '1px solid #e2e8f0', borderRadius: '8px', color: '#0f172a', fontSize: '13px', outline: 'none' },
//   formActionDock: { display: 'flex', justifyContent: 'flex-end', gap: '12px', marginTop: '8px', borderTop: '1px solid #e2e8f0', paddingTop: '12px' },
//   formCancelBtn: { background: 'transparent', border: '1px solid #e2e8f0', color: '#64748b', padding: '9px 16px', borderRadius: '8px', cursor: 'pointer' },
//   receiptChassis: {
//     background: '#ffffff',
//     border: '1px solid #e2e8f0',
//     borderRadius: '12px',
//     padding: '40px',
//     boxSizing: 'border-box',
//     boxShadow: '0 4px 20px rgba(0, 0, 0, 0.02)'
//   },
//   receiptHeader: {
//     display: 'flex',
//     alignItems: 'center',
//     gap: '16px',
//     borderBottom: '2px solid #1c6ec9', /* Brand Primary Key */
//     paddingBottom: '20px',
//     marginBottom: '24px'
//   },
//   receiptLogoBox: {
//     background: '#1c6ec9', /* Brand Primary Blue */
//     color: '#ffffff',
//     fontSize: '22px',
//     fontWeight: '800',
//     padding: '12px 16px',
//     borderRadius: '8px',
//     letterSpacing: '0.5px'
//   },
//   receiptInstitutionTitle: {
//     margin: 0,
//     fontSize: '18px',
//     fontWeight: '800',
//     color: '#0f172a',
//     letterSpacing: '0.2px'
//   },
//   receiptInstitutionSub: {
//     margin: '3px 0 0 0',
//     fontSize: '12.5px',
//     color: '#64748b',
//     fontWeight: '500'
//   },
//   receiptDocumentLabel: {
//     background: '#fff1f2',
//     border: '1px solid #fecaca',
//     color: '#a80302', /* Brand Crimson Red Accent */
//     padding: '4px 10px',
//     borderRadius: '6px',
//     fontSize: '11px',
//     fontWeight: '700',
//     letterSpacing: '0.5px',
//     textTransform: 'uppercase'
//   },
//   receiptMetaGrid: {
//     display: 'grid',
//     gridTemplateColumns: '1fr 1fr',
//     gap: '20px',
//     background: '#f8fafc',
//     border: '1px solid #e2e8f0',
//     borderRadius: '8px',
//     padding: '16px 20px',
//     marginBottom: '28px'
//   },
//   metaColumn: {
//     display: 'flex',
//     flexDirection: 'column',
//     gap: '8px'
//   },
//   metaRow: {
//     display: 'flex',
//     alignItems: 'center',
//     fontSize: '13px'
//   },
//   metaLabel: {
//     color: '#64748b',
//     width: '110px',
//     flexShrink: 0
//   },
//   metaValue: {
//     color: '#334155',
//     fontWeight: '600'
//   },
//   receiptTable: {
//     width: '100%',
//     borderCollapse: 'collapse',
//     marginBottom: '40px'
//   },
//   receiptTh: {
//     background: '#f1f5f9',
//     borderBottom: '1px solid #cbd5e1',
//     padding: '10px 12px',
//     fontSize: '11px',
//     fontWeight: '700',
//     textTransform: 'uppercase',
//     color: '#475569',
//     letterSpacing: '0.5px'
//   },
//   receiptTd: {
//     borderBottom: '1px solid #e2e8f0',
//     padding: '16px 12px',
//     fontSize: '13px',
//     color: '#334155'
//   },
//   receiptTdEmpty: {
//     borderBottom: '1px solid #e2e8f0',
//     padding: '24px 12px'
//   },
//   receiptTotalLabelCell: {
//     padding: '14px 12px',
//     fontSize: '13px',
//     fontWeight: '700',
//     textAlign: 'right',
//     color: '#475569'
//   },
//   receiptTotalValueCell: {
//     borderBottom: '2px double #1c6ec9',
//     padding: '14px 12px',
//     fontSize: '16px',
//     fontWeight: '800',
//     textAlign: 'right',
//     color: '#1c6ec9',
//     whiteSpace: 'nowrap'
//   },
//   receiptFooterSignatures: {
//     display: 'flex',
//     justifyContent: 'space-between',
//     marginTop: '70px',
//     padding: '0 16px'
//   },
//   signatureBox: {
//     display: 'flex',
//     flexDirection: 'column',
//     alignItems: 'center',
//     width: '180px',
//     fontSize: '11px',
//     color: '#64748b',
//     fontWeight: '600'
//   },
//   signatureLine: {
//     width: '100%',
//     borderBottom: '1px dashed #cbd5e1',
//     marginBottom: '6px'
//   },
//   receiptDisclaimer: {
//     textAlign: 'center',
//     fontSize: '10px',
//     color: '#94a3b8',
//     marginTop: '45px',
//     borderTop: '1px dashed #e2e8f0',
//     paddingTop: '12px'
//   },
//   receiptPrintSubmitBtn: {
//     background: 'linear-gradient(135deg, #459bf2 0%, #1c6ec9 100%)',
//     border: 'none',
//     color: '#ffffff',
//     padding: '9px 20px',
//     borderRadius: '8px',
//     fontWeight: '600',
//     cursor: 'pointer',
//     display: 'inline-flex',
//     alignItems: 'center',
//     gap: '6px',
//     boxShadow: '0 4px 12px rgba(28, 110, 201, 0.2)',
//     fontSize: '13px'
//   },

//   // Append these design properties inside your styles object matrix
//   paginationDock: {
//     display: 'flex',
//     justifyContent: 'flex-end',
//     alignItems: 'center',
//     gap: '12px',
//     marginTop: '16px',
//     paddingTop: '12px',
//     borderTop: '1px solid #edf2f7'
//   },
//   pageIndicator: {
//     fontSize: '13px',
//     color: '#475569'
//   },
//   pageBtn: {
//     background: '#ffffff',
//     border: '1px solid #e2e8f0',
//     borderRadius: '6px',
//     padding: '6px 14px',
//     color: '#334155',
//     fontSize: '12.5px',
//     fontWeight: '600',
//     cursor: 'pointer',
//     transition: 'all 0.2s'
//   },
//   pageBtnDisabled: {
//     background: '#f8fafc',
//     color: '#94a3b8',
//     cursor: 'not-allowed',
//     borderColor: '#e2e8f0'
//   },
//   formSaveBtn: { background: 'linear-gradient(90deg, #10b981 0%, #059669 100%)', border: 'none', color: '#fff', padding: '9px 16px', borderRadius: '8px', fontWeight: '600', cursor: 'pointer' }
// };





import React, { useState, useEffect } from 'react';
import * as XLSX from 'xlsx';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import { Search, Wallet, AlertCircle, History, X, Loader2, Printer, CheckCircle, Download, FileSpreadsheet } from 'lucide-react';

export default function FeeManagement() {
  const sessionUser = JSON.parse(sessionStorage.getItem('userSession')) || { name: "Admin Accounts" };

  const [activeTab, setActiveTab] = useState('ledger'); // ledger, pending, history
  const [feeData, setFeeData] = useState([]);
  const [receiptsLog, setReceiptsLog] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [tableLoading, setTableLoading] = useState(false);

  // Modal Popups Open & Configuration Flags
  const [isCollectModalOpen, setIsCollectModalOpen] = useState(false);
  const [isPrintModalOpen, setIsPrintModalOpen] = useState(false);
  
  const [selectedStudent, setSelectedStudent] = useState(null);
  const [selectedReceipt, setSelectedReceipt] = useState(null);

  const [courseCascades, setCourseCascades] = useState([]);

  // ➕ Filter dropdown states for Fee Category & Academic Term
const [selectedFeeType, setSelectedFeeType] = useState('ALL');
const [selectedSemester, setSelectedSemester] = useState('ALL');


const [paymentForm, setPaymentForm] = useState({ 
  target_course: '', 
  fee_type: 'Semester Fee', 
  academic_term: 'Semester 1', 
  amount_paid_now: '', 
  payment_mode: 'Online Transfer', 
  transaction_reference: '' 
});

// ➕ ADDED: Pagination Control Parameters
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 5;

  const administrativeTabs = [
    { id: 'ledger', name: 'Collect Fees Ledger', icon: Wallet },
    // { id: 'pending', name: 'Track Pending Installments', icon: AlertCircle },
    { id: 'history', name: 'Payment Receipts History', icon: History }
  ];


  useEffect(() => {
  const fetchCascades = async () => {
    try {
      const res = await fetch('https://metapi.emedhatechnologies.com/api/academic-updates/course-cascades');
      const result = await res.json();
      if (result.success) {
        setCourseCascades(result.data || []);
      }
    } catch (err) {
      console.error("Failed to load course cascades:", err);
    }
  };
  fetchCascades();
}, []);



// Helper to find the matched course configuration from cascades
const getSelectedCourseInfo = (courseName) => {
  if (!courseName) return null;
  return courseCascades.find(
    (c) => c.course_name.trim().toLowerCase() === courseName.trim().toLowerCase()
  ) || null;
};

// 1. 📊 Export Current Tab Data to Excel
const handleExportToExcel = () => {
 // At the top of handleExportToExcel and handleExportToPDF:
const currentData = currentActiveData;
  if (!currentData || currentData.length === 0) {
    alert("No records available to export.");
    return;
  }

  let formattedData = [];
  let sheetTitle = "";

  if (activeTab === 'history') {
    sheetTitle = "Fee_Receipts_History";
    formattedData = currentData.map((rec, index) => ({
      "S.No": index + 1,
      "Receipt Number": rec.receipt_number || 'N/A',
      "Admission No": rec.adm_number || 'N/A',
      "Student Name": rec.name || 'N/A',
      "Course": rec.target_course || 'N/A',
      "Fee Category": rec.fee_type || 'Tuition Fee',
      "Academic Term": rec.academic_term || 'N/A',
      "Payment Mode": rec.payment_mode || 'N/A',
      "Transaction Ref": rec.transaction_reference || 'N/A',
      "Amount Paid (INR)": Number(rec.amount_paid_now || 0),
      "Date of Payment": rec.payment_date ? new Date(rec.payment_date).toLocaleDateString('en-IN') : 'N/A',
      "Collected By": rec.collected_by_name || 'Accounts Staff'
    }));
  } else {
    sheetTitle = "Collect_Fees_Ledger";
    formattedData = currentData.map((item, index) => ({
      "S.No": index + 1,
      "Admission No": item.adm_number || 'N/A',
      "Student Name": item.name || 'N/A',
      "Contact Mobile": item.mobile || 'N/A',
      "Enrolled Course": item.target_course || 'N/A',
      "Campus Center": item.college_university || 'N/A',
      "Total Agreed Fees (INR)": Number(item.total_agreed_fees || 0),
      "Total Paid Amount (INR)": Number(item.total_paid_amount || 0)
    }));
  }

  const worksheet = XLSX.utils.json_to_sheet(formattedData);
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, sheetTitle);

  const fileName = `${sheetTitle}_${new Date().toISOString().substring(0, 10)}.xlsx`;
  XLSX.writeFile(workbook, fileName);
};

// 2. 📄 Export Professional PDF Statement Report
const handleExportToPDF = () => {
 // At the top of handleExportToExcel and handleExportToPDF:
const currentData = currentActiveData;
  if (!currentData || currentData.length === 0) {
    alert("No records available to generate PDF.");
    return;
  }

  const doc = new jsPDF({ orientation: 'landscape', unit: 'pt', format: 'a4' });
  const isHistory = activeTab === 'history';
  const reportTitle = isHistory ? "OFFICIAL FEE RECEIPTS LOG" : "ACADEMIC STUDENT FEE LEDGER";

  // Top Header Banner
  doc.setFillColor(15, 23, 42); // #0f172a Dark Slate
  doc.rect(0, 0, doc.internal.pageSize.width, 60, 'F');

  doc.setFont('helvetica', 'bold');
  doc.setFontSize(16);
  doc.setTextColor(255, 255, 255);
  doc.text("Edulearner OF HIGHER EDUCATION", 40, 30);

  doc.setFontSize(10);
  doc.setFont('helvetica', 'normal');
  doc.setTextColor(148, 163, 184);
  doc.text("Finance & Accounts Administration Portal", 40, 46);

  doc.setFontSize(11);
  doc.setFont('helvetica', 'bold');
  doc.setTextColor(56, 189, 248); // Accent Blue
  doc.text(reportTitle, doc.internal.pageSize.width - 40, 32, { align: 'right' });

  doc.setFontSize(9);
  doc.setFont('helvetica', 'normal');
  doc.setTextColor(203, 213, 225);
  doc.text(`Generated on: ${new Date().toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: 'numeric' })}`, doc.internal.pageSize.width - 40, 46, { align: 'right' });

  // Compute Grand Total
  const totalSum = currentData.reduce((acc, row) => acc + Number(isHistory ? row.amount_paid_now : row.total_paid_amount || 0), 0);

  // Table Configuration
  if (isHistory) {
    const tableColumns = [
      { header: '#', dataKey: 'index' },
      { header: 'Receipt No.', dataKey: 'receipt_number' },
      { header: 'Adm No.', dataKey: 'adm_number' },
      { header: 'Student Name', dataKey: 'name' },
      { header: 'Course Track', dataKey: 'target_course' },
      { header: 'Category', dataKey: 'fee_type' },
      { header: 'Term', dataKey: 'academic_term' },
      { header: 'Mode', dataKey: 'payment_mode' },
      { header: 'Amount', dataKey: 'amount' }
    ];

    const tableRows = currentData.map((rec, i) => ({
      index: String(i + 1).padStart(2, '0'),
      receipt_number: rec.receipt_number || 'N/A',
      adm_number: rec.adm_number || 'N/A',
      name: (rec.name || 'N/A').toUpperCase(),
      target_course: rec.target_course || 'General',
      fee_type: rec.fee_type || 'Tuition Fee',
      academic_term: rec.academic_term || 'N/A',
      payment_mode: rec.payment_mode || 'Online',
      amount: `INR ${Number(rec.amount_paid_now || 0).toLocaleString('en-IN')}.00`
    }));

    autoTable(doc, {
      startY: 75,
      columns: tableColumns,
      body: tableRows,
      theme: 'grid',
      headStyles: { fillColor: [28, 110, 201], textColor: [255, 255, 255], fontStyle: 'bold', fontSize: 9 },
      bodyStyles: { fontSize: 8.5, textColor: [51, 65, 85] },
      alternateRowStyles: { fillColor: [248, 250, 252] },
      columnStyles: {
        index: { halign: 'center', cellWidth: 28 },
        amount: { halign: 'right', fontStyle: 'bold', textColor: [16, 185, 129] }
      },
      margin: { left: 40, right: 40, bottom: 50 },
      didDrawPage: (data) => {
        // Footer Page Numbering
        doc.setFontSize(8);
        doc.setTextColor(148, 163, 184);
        doc.text(`Page ${doc.internal.getNumberOfPages()}`, doc.internal.pageSize.width - 40, doc.internal.pageSize.height - 20, { align: 'right' });
        doc.text("Official Computer-Generated Financial Record • Edulearner", 40, doc.internal.pageSize.height - 20);
      }
    });
  } else {
    const tableColumns = [
      { header: '#', dataKey: 'index' },
      { header: 'Adm No.', dataKey: 'adm_number' },
      { header: 'Student Name', dataKey: 'name' },
      { header: 'Mobile', dataKey: 'mobile' },
      { header: 'Course Track', dataKey: 'target_course' },
      { header: 'Campus', dataKey: 'college_university' },
      { header: 'Agreed Fee', dataKey: 'agreed' },
      { header: 'Paid Amount', dataKey: 'paid' }
    ];

    const tableRows = currentData.map((item, i) => ({
      index: String(i + 1).padStart(2, '0'),
      adm_number: item.adm_number || 'N/A',
      name: (item.name || 'N/A').toUpperCase(),
      mobile: item.mobile || 'N/A',
      target_course: item.target_course || 'General',
      college_university: item.college_university || 'Main Campus',
      agreed: `INR ${Number(item.total_agreed_fees || 0).toLocaleString('en-IN')}`,
      paid: `INR ${Number(item.total_paid_amount || 0).toLocaleString('en-IN')}`
    }));

    autoTable(doc, {
      startY: 75,
      columns: tableColumns,
      body: tableRows,
      theme: 'grid',
      headStyles: { fillColor: [28, 110, 201], textColor: [255, 255, 255], fontStyle: 'bold', fontSize: 9 },
      bodyStyles: { fontSize: 8.5, textColor: [51, 65, 85] },
      alternateRowStyles: { fillColor: [248, 250, 252] },
      columnStyles: {
        index: { halign: 'center', cellWidth: 28 },
        agreed: { halign: 'right', fontStyle: 'bold', textColor: [15, 23, 42] },
        paid: { halign: 'right', fontStyle: 'bold', textColor: [16, 185, 129] }
      },
      margin: { left: 40, right: 40, bottom: 50 },
      didDrawPage: (data) => {
        doc.setFontSize(8);
        doc.setTextColor(148, 163, 184);
        doc.text(`Page ${doc.internal.getNumberOfPages()}`, doc.internal.pageSize.width - 40, doc.internal.pageSize.height - 20, { align: 'right' });
        doc.text("Official Computer-Generated Financial Record • Edulearner", 40, doc.internal.pageSize.height - 20);
      }
    });
  }

  // Final Summary Row
  const finalY = doc.lastAutoTable.finalY + 18;
  if (finalY < doc.internal.pageSize.height - 50) {
    doc.setFillColor(241, 245, 249);
    doc.roundedRect(doc.internal.pageSize.width - 290, finalY - 10, 250, 28, 4, 4, 'F');
    doc.setFont('helvetica', 'bold');
    doc.setFontSize(10);
    doc.setTextColor(15, 23, 42);
    doc.text(`Total Amount Collected: INR ${totalSum.toLocaleString('en-IN')}.00`, doc.internal.pageSize.width - 50, finalY + 8, { align: 'right' });
  }

  const fileName = `${isHistory ? 'Fee_Receipts_History' : 'Fee_Ledger_Statement'}_${new Date().toISOString().substring(0, 10)}.pdf`;
  doc.save(fileName);
};


  useEffect(() => {
    if (activeTab === 'history') {
      fetchReceiptsLog();
    } else {
      fetchFeeSummaries();
    }
  }, [activeTab, searchTerm]);

  const fetchFeeSummaries = async () => {
    setTableLoading(true);
    try {
      const res = await fetch(`https://metapi.emedhatechnologies.com/api/fees?activeTab=${activeTab}&search=${encodeURIComponent(searchTerm)}`);
      const result = await res.json();
      if (result.success) setFeeData(result.data);
    } catch (err) { console.error(err); }
    finally { setTableLoading(false); }
  };

  const fetchReceiptsLog = async () => {
    setTableLoading(true);
    try {
      const res = await fetch('https://metapi.emedhatechnologies.com/api/fees/receipts-history');
      const result = await res.json();
      if (result.success) setReceiptsLog(result.data);
    } catch (err) { console.error(err); }
    finally { setTableLoading(false); }
  };



  
// const handleOpenCollectFees = (student) => {
//   const computedBalanceDue = Number(student.pending_balance_due) > 0 
//     ? student.pending_balance_due 
//     : (Number(student.total_agreed_fees) - Number(student.total_paid_amount)) || 0;

//   setSelectedStudent({
//     ...student,
//     pending_balance_due: computedBalanceDue
//   });

//   const studentCourses = student.target_course 
//     ? student.target_course.split(',').map(c => c.trim()) 
//     : ['General Course'];

//   const initialCourse = studentCourses[0];
//   const courseInfo = getSelectedCourseInfo(initialCourse);
//   const isNonSemester = courseInfo?.structure_type === 'Non-Semester';

//   // Extract first available term label (e.g. 'Semester 1' or 'Year 1')
//   const defaultTerm = courseInfo?.semester_details?.[0]?.term_label 
//     || (isNonSemester ? 'Year 1' : 'Semester 1');

//   setPaymentForm({ 
//     target_course: initialCourse, 
//     fee_type: isNonSemester ? 'Yearly Fee' : 'Semester Fee', 
//     academic_term: defaultTerm, 
//     amount_paid_now: '', 
//     payment_mode: 'Online Transfer', 
//     transaction_reference: '' 
//   });

//   setIsCollectModalOpen(true);
// };


const handleOpenCollectFees = (student) => {
  setSelectedStudent(student);

  const studentCourses = student.target_course 
    ? student.target_course.split(',').map(c => c.trim()) 
    : ['General Course'];

  const initialCourse = studentCourses[0];
  const courseInfo = getSelectedCourseInfo(initialCourse);
  const isNonSemester = courseInfo?.structure_type === 'Non-Semester';

  const defaultTerm = courseInfo?.semester_details?.[0]?.term_label 
    || (isNonSemester ? 'Year 1' : 'Semester 1');

  setPaymentForm({ 
    target_course: initialCourse, 
    fee_type: isNonSemester ? 'Yearly Fee' : 'Semester Fee', 
    academic_term: defaultTerm, 
    amount_paid_now: '', 
    payment_mode: 'Online Transfer', 
    transaction_reference: '' 
  });

  setIsCollectModalOpen(true);
};


const handleSendReceiptWhatsApp = (receipt) => {
  if (!receipt) return;

  // 1. Format mobile number (91XXXXXXXXXX)
  let rawMobile = String(receipt.mobile || '').replace(/\D/g, '');
  if (rawMobile.length === 10) {
    rawMobile = '91' + rawMobile;
  }

  // 2. Format receipt date
  const receiptDate = receipt.payment_date 
    ? new Date(receipt.payment_date).toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: 'numeric' }) 
    : new Date().toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: 'numeric' });

  // 3. Draft formatted WhatsApp receipt
  const messageBody = 
`🧾 *Official Fee Receipt Voucher - Edulearner*

Dear *${receipt.name}*,

Here is your official fee transaction voucher:

🧾 *Receipt No:* ${receipt.receipt_number}
📋 *Admission No:* ${receipt.adm_number}
🎓 *Course:* ${receipt.target_course}
📅 *Academic Term:* ${receipt.academic_term}
🏢 *Campus / Center:* ${receipt.college_university || 'Main Campus'}
💰 *Amount Received:* ₹${Number(receipt.amount_paid_now).toLocaleString('en-IN')}.00
💳 *Payment Mode:* ${receipt.payment_mode}
🔢 *Txn / Reference ID:* ${receipt.transaction_reference || 'N/A'}
📅 *Date of Payment:* ${receiptDate}

This is a computer-generated voucher issued by the Edulearner Finance Portal.

For any queries, please contact the Edulearner accounts desk.

Warm Regards,
*Edulearner Accounts Department*`;

  // 4. Open WhatsApp Web / App directly
  if (rawMobile && rawMobile.length >= 10) {
    const waUrl = `https://api.whatsapp.com/send?phone=${rawMobile}&text=${encodeURIComponent(messageBody)}`;
    const link = document.createElement('a');
    link.href = waUrl;
    link.target = '_blank';
    link.rel = 'noopener noreferrer';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  } else {
    alert("Warning: Student mobile number is missing or invalid for this receipt.");
  }
};

const handleCourseChangeInModal = (newCourse) => {
  const courseInfo = getSelectedCourseInfo(newCourse);
  const isNonSemester = courseInfo?.structure_type === 'Non-Semester';
  const defaultTerm = courseInfo?.semester_details?.[0]?.term_label 
    || (isNonSemester ? 'Year 1' : 'Semester 1');

  setPaymentForm((prev) => ({
    ...prev,
    target_course: newCourse,
    fee_type: isNonSemester ? 'Yearly Fee' : 'Semester Fee',
    academic_term: defaultTerm
  }));
};

  // const handleCollectFeesSubmit = async (e) => {
  //   e.preventDefault();
  //   try {
  //     const res = await fetch('https://metapi.emedhatechnologies.com/api/fees/collect-payment', {
  //       method: 'POST',
  //       headers: { 'Content-Type': 'application/json' },
  //       body: JSON.stringify({ student_id: selectedStudent.student_id, ...paymentForm, sessionUser })
  //     });
  //     if ((await res.json()).success) {
  //       setIsCollectModalOpen(false);
  //       fetchFeeSummaries();
  //     }
  //   } catch (err) { console.error(err); }
  // };


  useEffect(() => {
    if (activeTab === 'history') {
      fetchReceiptsLog();
    } else {
      fetchFeeSummaries();
    }
  }, [activeTab, activeTab === 'history' ? null : searchTerm]);

const handleCollectFeesSubmit = async (e) => {
  e.preventDefault();

  try {
    // 1. Map frontend state directly to what your existing backend requires
    const selectedCourse = paymentForm.target_course || selectedStudent?.target_course || 'Academic Program';
    const selectedTerm = paymentForm.academic_term || paymentForm.term_label || selectedStudent?.current_semester || 'Semester 1';
    const amountPaid = paymentForm.amount_paid_now || paymentForm.paid_amount || paymentForm.amount || 0;
    const paymentMode = paymentForm.payment_mode || paymentForm.payment_method || 'Online / Cash';
    const txnRef = paymentForm.transaction_reference || paymentForm.transaction_id || `TXN-${Date.now().toString().slice(-6)}`;
    const feeType = paymentForm.fee_type || 'Tuition / Semester Fee';

    const payload = {
      student_id: selectedStudent?.student_id || selectedStudent?.id,
      target_course: selectedCourse,
      fee_type: feeType,
      academic_term: selectedTerm,
      amount_paid_now: amountPaid,
      payment_mode: paymentMode,
      transaction_reference: txnRef,
      sessionUser: sessionUser || { id: 1, name: "Accounts Staff" }
    };

    // 2. Call your existing backend endpoint
    const res = await fetch('https://metapi.emedhatechnologies.com/api/fees/collect-payment', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
    });

    const result = await res.json();

    if (result.success) {
      // 3. Format student phone number (91XXXXXXXXXX)
      let rawMobile = String(selectedStudent?.mobile || '').replace(/\D/g, '');
      if (rawMobile.length === 10) {
        rawMobile = '91' + rawMobile;
      }

      // 4. Construct receipt details
      const receiptNo = `MET-REC-${Date.now()}`;
      const studentAdmNo = selectedStudent?.adm_number || selectedStudent?.roll_number || `MET-ADM-${selectedStudent?.id || selectedStudent?.student_id}`;
      const paymentDate = paymentForm.payment_date || new Date().toISOString().substring(0, 10);

      // 5. Draft formatted WhatsApp receipt
      const messageBody = 
`💳 *Fee Payment Acknowledgment - Edulearner*

Dear *${selectedStudent?.name}*,

Thank you for your payment! We have successfully received your fee installment. Here are your transaction details:


📋 *Admission No:* ${studentAdmNo}
🎓 *Course:* ${selectedCourse}
📅 *Term / Semester:* ${selectedTerm}
🏷️ *Fee Type:* ${feeType}
💰 *Amount Paid:* ₹${Number(amountPaid).toLocaleString('en-IN')}
💳 *Payment Mode:* ${paymentMode}
🔢 *Txn / Reference ID:* ${txnRef}
📅 *Payment Date:* ${paymentDate}

Your payment has been officially recorded and updated in your student account.

For any queries regarding your fee receipt or ledger balance, please contact the Edulearner accounts desk.

Warm Regards,
*Edulearner Accounts Department*`;

      // 6. Trigger WhatsApp Web tab
      if (rawMobile && rawMobile.length >= 10) {
        const waUrl = `https://api.whatsapp.com/send?phone=${rawMobile}&text=${encodeURIComponent(messageBody)}`;
        
        const link = document.createElement('a');
        link.href = waUrl;
        link.target = '_blank';
        link.rel = 'noopener noreferrer';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      } else {
        console.warn("Student mobile number is missing or invalid. WhatsApp skipped.");
      }

      // 7. Close modal and refresh records
      setIsCollectModalOpen(false);
      if (typeof fetchFeeSummaries === 'function') {
        fetchFeeSummaries();
      }
      alert(`Payment of ₹${Number(amountPaid).toLocaleString('en-IN')} recorded successfully!`);
    } else {
      alert("Failed to collect payment: " + (result.message || "Unknown server error"));
    }
  } catch (err) {
    console.error("Fee payment processing error:", err);
    alert("Network error while recording fee payment.");
  }
};


  const triggerPrintReceipt = (receipt) => {
    setSelectedReceipt(receipt);
    setIsPrintModalOpen(true);
  };

  // ➕ Direct PDF download for a single voucher
const handleDownloadSingleReceiptPDF = (receipt) => {
  if (!receipt) return;
  const doc = new jsPDF({ unit: 'pt', format: 'a4' });

  // Header Banner
  doc.setFillColor(15, 23, 42);
  doc.rect(0, 0, doc.internal.pageSize.width, 60, 'F');
  doc.setFont('helvetica', 'bold');
  doc.setFontSize(16);
  doc.setTextColor(255, 255, 255);
  doc.text("EDULEARNER HIGHER EDUCATION", 40, 30);
  doc.setFontSize(10);
  doc.setFont('helvetica', 'normal');
  doc.setTextColor(148, 163, 184);
  doc.text(receipt.college_university || "Main Campus Center", 40, 46);

  doc.setFontSize(12);
  doc.setFont('helvetica', 'bold');
  doc.setTextColor(56, 189, 248);
  doc.text("FEE PAYMENT RECEIPT", doc.internal.pageSize.width - 40, 38, { align: 'right' });

  // Metadata Table
  autoTable(doc, {
    startY: 80,
    theme: 'plain',
    body: [
      ['Receipt Number:', receipt.receipt_number || 'N/A', 'Payment Date:', receipt.payment_date ? new Date(receipt.payment_date).toLocaleDateString('en-IN') : 'N/A'],
      ['Admission No:', receipt.adm_number || 'N/A', 'Course Track:', receipt.target_course || 'N/A'],
      ['Student Name:', (receipt.name || 'N/A').toUpperCase(), 'Category / Term:', `${receipt.fee_type || 'Tuition Fee'} (${receipt.academic_term || 'N/A'})`],
      ['Payment Mode:', receipt.payment_mode || 'N/A', 'Txn Reference:', receipt.transaction_reference || 'N/A']
    ],
    styles: { fontSize: 9, textColor: [51, 65, 85], cellPadding: 3 },
    columnStyles: {
      0: { fontStyle: 'bold', cellWidth: 100 },
      2: { fontStyle: 'bold', cellWidth: 100 }
    }
  });

  // Particulars Breakdown
  autoTable(doc, {
    startY: doc.lastAutoTable.finalY + 15,
    theme: 'grid',
    head: [['#', 'Fee Breakdown Description', 'Amount Paid']],
    body: [
      ['01', `${receipt.fee_type || 'Tuition Fee'} – ${receipt.academic_term || 'Term'} Allocation`, `INR ${Number(receipt.amount_paid_now || 0).toLocaleString('en-IN')}.00`],
      ['', 'Total Amount Received', `INR ${Number(receipt.amount_paid_now || 0).toLocaleString('en-IN')}.00`]
    ],
    headStyles: { fillColor: [28, 110, 201], textColor: [255, 255, 255], fontStyle: 'bold' },
    bodyStyles: { fontSize: 9 },
    columnStyles: {
      0: { halign: 'center', cellWidth: 30 },
      2: { halign: 'right', fontStyle: 'bold' }
    }
  });

  doc.save(`Receipt_${receipt.receipt_number || 'Voucher'}.pdf`);
};


  // ➕ ADDED: Pagination Slicing Matrix Computation
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  
// ➕ Frontend search filter for Payment Receipts History
  // const filteredReceipts = receiptsLog.filter((rec) => {
  //   if (!searchTerm.trim()) return true;
  //   const term = searchTerm.toLowerCase();
  //   const name = (rec.name || '').toLowerCase();
  //   const adm = (rec.adm_number || '').toLowerCase();
  //   const receipt = (rec.receipt_number || '').toLowerCase();
  //   const course = (rec.target_course || '').toLowerCase();
  //   const txn = (rec.transaction_reference || '').toLowerCase();
  //   const mode = (rec.payment_mode || '').toLowerCase();
  //   const feeType = (rec.fee_type || '').toLowerCase();
  //   const termLabel = (rec.academic_term || '').toLowerCase();

  //   return (
  //     name.includes(term) ||
  //     adm.includes(term) ||
  //     receipt.includes(term) ||
  //     course.includes(term) ||
  //     txn.includes(term) ||
  //     mode.includes(term) ||
  //     feeType.includes(term) ||
  //     termLabel.includes(term)
  //   );
  // });

  // ➕ Point active data to filtered receipts when on 'history' tab
  // const currentActiveData = activeTab === 'history' ? filteredReceipts : feeData;
  // const currentItems = currentActiveData.slice(indexOfFirstItem, indexOfLastItem);
  // const totalPages = Math.ceil(currentActiveData.length / itemsPerPage);

  // ➕ Multi-parameter frontend search & category filter
// 1. Filter for Collect Fees Ledger (Search only)
  const filteredLedger = feeData.filter((item) => {
    if (!searchTerm.trim()) return true;
    const term = searchTerm.toLowerCase();
    const name = (item.name || '').toLowerCase();
    const adm = (item.adm_number || '').toLowerCase();
    const course = (item.target_course || '').toLowerCase();
    const campus = (item.college_university || '').toLowerCase();
    const mobile = (item.mobile || '').toLowerCase();

    return name.includes(term) || adm.includes(term) || course.includes(term) || campus.includes(term) || mobile.includes(term);
  });

  // 2. Filter for Payment Receipts History (Search + Fee Type + Semester)
  const filteredReceipts = receiptsLog.filter((rec) => {
    // Fee Category Filter
    if (selectedFeeType !== 'ALL') {
      const feeType = (rec.fee_type || '').toLowerCase();
      if (!feeType.includes(selectedFeeType.toLowerCase())) return false;
    }

    // Academic Term / Semester Filter
    if (selectedSemester !== 'ALL') {
      const term = (rec.academic_term || '').toLowerCase();
      if (term !== selectedSemester.toLowerCase()) return false;
    }

    // Search Filter
    if (!searchTerm.trim()) return true;
    const term = searchTerm.toLowerCase();
    const name = (rec.name || '').toLowerCase();
    const adm = (rec.adm_number || '').toLowerCase();
    const receipt = (rec.receipt_number || '').toLowerCase();
    const course = (rec.target_course || '').toLowerCase();
    const txn = (rec.transaction_reference || '').toLowerCase();
    const mode = (rec.payment_mode || '').toLowerCase();

    return (
      name.includes(term) ||
      adm.includes(term) ||
      receipt.includes(term) ||
      course.includes(term) ||
      txn.includes(term) ||
      mode.includes(term)
    );
  });

  // Set active dataset
  const currentActiveData = activeTab === 'history' ? filteredReceipts : filteredLedger;
  const currentItems = currentActiveData.slice(indexOfFirstItem, indexOfLastItem);
  const totalPages = Math.ceil(currentActiveData.length / itemsPerPage);


  return (
    <div>
      {/* STEP 1: TOP NAVIGATION MENU TABS */}
      <div style={styles.topActionBar}>
        <div style={styles.tabScrollGroup}>
         {/* Update your administrativeTabs mapping inside the JSX return */}
{administrativeTabs.map((tab) => {
  const Icon = tab.icon;
  return (
    <button 
      key={tab.id} 
      onClick={() => { 
        setActiveTab(tab.id); 
        setSearchTerm(''); 
        setSelectedFeeType('ALL'); // ➕ Reset category filter
        setSelectedSemester('ALL'); // ➕ Reset semester filter
        setCurrentPage(1); 
      }} 
      style={{ ...styles.tabBtn, ...(activeTab === tab.id ? styles.tabBtnActive : {}) }}
    >
      <Icon size={15} style={{ marginRight: '6px' }} /> {tab.name}
    </button>
  );
})}
        </div>
      </div>

      {/* STEP 2: SEARCH FILTER BAR CONTROLS */}
{/* STEP 2: SEARCH FILTER & EXPORT ACTION DOCK */}
{/* STEP 2: SEARCH FILTER & EXPORT ACTION DOCK */}
<div style={styles.filterControlPanel}>
  <div style={styles.searchWrapper}>
    <Search size={16} style={styles.searchIcon} />
    <input 
      type="text" 
      placeholder={activeTab === 'history' ? "Search receipt, student name, adm no..." : "Search by student name, admission number..."} 
      value={searchTerm} 
      onChange={(e) => { 
        setSearchTerm(e.target.value); 
        setCurrentPage(1);
      }} 
      style={styles.tableSearchInput} 
    />
  </div>

  {/* ➕ Category & Semester Dropdown Selectors - ONLY for Payment Receipts History */}
  {activeTab === 'history' && (
    <div style={{ display: 'flex', alignItems: 'center', gap: '8px', flexWrap: 'wrap' }}>
      <select
        value={selectedFeeType}
        onChange={(e) => { setSelectedFeeType(e.target.value); setCurrentPage(1); }}
        style={styles.filterSelectBox}
      >
        <option value="ALL">All Categories</option>
        <option value="Semester Fee">Semester Tuition Fee</option>
        <option value="Exam Fee">Exam Fee</option>
        <option value="Practical Fee">Practical Fee</option>
        <option value="Project Fee">Project Fee</option>
        <option value="Arrear Fee">Arrear Fee</option>
        <option value="Admission Deposit">Admission Deposit</option>
      </select>

      <select
        value={selectedSemester}
        onChange={(e) => { setSelectedSemester(e.target.value); setCurrentPage(1); }}
        style={styles.filterSelectBox}
      >
        <option value="ALL">All Semesters / Years</option>
        <option value="Semester 1">Semester 1</option>
        <option value="Semester 2">Semester 2</option>
        <option value="Semester 3">Semester 3</option>
        <option value="Semester 4">Semester 4</option>
        <option value="Semester 5">Semester 5</option>
        <option value="Semester 6">Semester 6</option>
        <option value="Year 1">Year 1</option>
        <option value="Year 2">Year 2</option>
        <option value="Year 3">Year 3</option>
      </select>

      {(selectedFeeType !== 'ALL' || selectedSemester !== 'ALL') && (
        <button
          type="button"
          onClick={() => { setSelectedFeeType('ALL'); setSelectedSemester('ALL'); setCurrentPage(1); }}
          style={styles.resetFilterBtn}
        >
          Reset
        </button>
      )}
    </div>
  )}

  {/* Export Buttons & Active Counter */}
  <div style={{ display: 'flex', alignItems: 'center', gap: '8px', flexWrap: 'wrap' }}>
    <button 
      type="button" 
      onClick={handleExportToExcel} 
      style={styles.excelExportBtn}
      title="Export records to Excel spreadsheet (.xlsx)"
    >
      <FileSpreadsheet size={14} /> Export Excel
    </button>

    <button 
      type="button" 
      onClick={handleExportToPDF} 
      style={styles.pdfExportBtn}
      title="Download clean printable statement (.pdf)"
    >
      <Download size={14} /> Download PDF
    </button>

    <div style={styles.totalIndicator}>
      Active: <strong style={{ color: '#459bf2' }}>{currentActiveData.length}</strong>
    </div>
  </div>
</div>

      {/* STEP 3: DATA LEDGER VIEWS GRID */}
      {tableLoading ? (
        <div style={{ display: 'flex', justifyContent: 'center', padding: '40px' }}><Loader2 size={32} style={{ animation: 'spin 1s linear infinite' }} color="#459bf2" /></div>
      ) : (
        <div style={{ overflowX: 'auto', width: '100%' }}>
          {activeTab !== 'history' ? (
            <table style={styles.dataTable}>
              <thead>
                <tr>
                  <th style={styles.tableTh}>Admission No.</th>
                  <th style={styles.tableTh}>Student Details</th>
                  <th style={styles.tableTh}>Enrolled Course</th>
                  <th style={styles.tableTh}>Campus Location</th>
                  <th style={styles.tableTh}>Total Agreed Fees</th>
                  <th style={styles.tableTh}>Total Paid Amount</th>
                  {/* <th style={styles.tableTh}>Pending Balance Due</th> */}
                  <th style={styles.tableTh}>Actions</th>
                </tr>
              </thead>
              <tbody>
                {currentItems.map((item) => (
                  <tr key={item.id} style={styles.tableTr}>
                   {/* Change item.roll_number to item.adm_number inside your table mapping loop */}
<td style={{ ...styles.tableTd, fontWeight: '700' }}>{item.adm_number}</td>
                    <td style={styles.tableTd}><strong>{item.name}</strong><br/><small style={{ color: '#64748b' }}>{item.mobile}</small></td>
                    <td style={styles.tableTd}><span style={styles.courseBadge}>{item.target_course}</span></td>
                    <td style={styles.tableTd}>{item.college_university}</td>
                    <td style={{ ...styles.tableTd, fontWeight: '600', color: '#0f172a' }}>₹{Number(item.total_agreed_fees).toLocaleString('en-IN')}</td>
                    <td style={{ ...styles.tableTd, fontWeight: '600', color: '#10b981' }}>₹{Number(item.total_paid_amount).toLocaleString('en-IN')}</td>
                  
                  
                  
                 {/* Pending Balance Cell */}
{/* <td style={{ ...styles.tableTd, fontWeight: '700', color: Number(item.pending_balance_due) > 0 || Number(item.total_agreed_fees) === 0 ? '#e30504' : '#15803d' }}>
  {Number(item.total_agreed_fees) === 0 ? (
    <span style={{ color: '#d97706' }}>Unset / Pending Setup</span>
  ) : Number(item.pending_balance_due) > 0 ? (
    `₹${Number(item.pending_balance_due).toLocaleString('en-IN')}`
  ) : (
    'Fully Paid ✓'
  )}
</td> */}

{/* Action Button Cell */}
<td style={styles.tableTd}>
<button onClick={() => handleOpenCollectFees(item)} style={styles.collectBtn}>
    Collect Fees
  </button>
</td>
                  </tr>
                ))}
              </tbody>
            </table>
          ) : (
            <table style={styles.dataTable}>
              <thead>
                <tr>
                  <th style={styles.tableTh}>Receipt Number</th>
                  <th style={styles.tableTh}>Admission No.</th>
                  <th style={styles.tableTh}>Student Name</th>
                  <th style={styles.tableTh}>Assigned Course</th>
                  <th style={styles.tableTh}>Fee Category</th>
                  <th style={styles.tableTh}>Academic Term</th>
                  <th style={styles.tableTh}>Payment Mode</th>
                  <th style={styles.tableTh}>Amount Paid</th>
                  <th style={styles.tableTh}>Receipt print</th>
                </tr>
              </thead>
              <tbody>
                {currentItems.map((rec) => (
                  <tr key={rec.id} style={styles.tableTr}>
                    <td style={{ ...styles.tableTd, fontWeight: '600' }}>{rec.receipt_number}</td>
                    <td style={styles.tableTd}>{rec.adm_number}</td>
                    <td style={styles.tableTd}><strong>{rec.name}</strong></td>
                    <td style={styles.tableTd}>{rec.target_course}</td>
                    <td style={styles.tableTd}>
          <span style={{ 
            background: rec.fee_type?.includes('Exam') ? '#fef3c7' : rec.fee_type?.includes('Practical') ? '#f3e8ff' : rec.fee_type?.includes('Project') ? '#e0f2fe' : rec.fee_type?.includes('Arrear') ? '#fee2e2' : '#ecfdf5',
            color: rec.fee_type?.includes('Exam') ? '#92400e' : rec.fee_type?.includes('Practical') ? '#6b21a8' : rec.fee_type?.includes('Project') ? '#0369a1' : rec.fee_type?.includes('Arrear') ? '#991b1b' : '#065f46',
            border: '1px solid rgba(0,0,0,0.06)',
            padding: '3px 8px',
            borderRadius: '5px',
            fontSize: '11.5px',
            fontWeight: '700',
            display: 'inline-block'
          }}>
            {rec.fee_type || 'Tuition Fee'}
          </span>
        </td>
                    <td style={styles.tableTd}><span style={styles.termLabel}>{rec.academic_term}</span></td>
                    <td style={styles.tableTd}>{rec.payment_mode}</td>
                    <td style={{ ...styles.tableTd, fontWeight: '700', color: '#10b981' }}>₹{Number(rec.amount_paid_now).toLocaleString('en-IN')}</td>
                    <td style={styles.tableTd}>
                      <button onClick={() => triggerPrintReceipt(rec)} style={styles.printActionBtn}><Printer size={13} /> Print Voucher</button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      )}


      {/* ➕ ADDED: PAGINATION BAR CONTROLS */}
      {currentActiveData.length > 0 && (
        <div style={styles.paginationDock}>
          <button 
            disabled={currentPage === 1} 
            onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))}
            style={currentPage === 1 ? { ...styles.pageBtn, ...styles.pageBtnDisabled } : styles.pageBtn}
          >
            Previous
          </button>
          <span style={styles.pageIndicator}>
            Page <strong>{currentPage}</strong> of {totalPages || 1}
          </span>
          <button 
            disabled={currentPage === totalPages || totalPages === 0} 
            onClick={() => setCurrentPage(prev => Math.min(prev + 1, totalPages))}
            style={currentPage === totalPages || totalPages === 0 ? { ...styles.pageBtn, ...styles.pageBtnDisabled } : styles.pageBtn}
          >
            Next
          </button>
        </div>
      )}

      {/* MODAL 1: RECORD AND COLLECT LIVE PAYMENT TRANSACTION */}
  {/* RECORD FEE PAYMENT MODAL */}
{isCollectModalOpen && (
  <div style={styles.modalBackdrop}>
    <div style={styles.modalWrapperCard}>
      <div style={styles.modalHeader}>
        <h3 style={{ margin: 0, fontSize: '15px' }}>Record Live Student Fee Payment</h3>
        <button onClick={() => setIsCollectModalOpen(false)} style={styles.modalCloseX}><X size={18} /></button>
      </div>
      <form onSubmit={handleCollectFeesSubmit} style={styles.modalForm}>
      <div style={{ padding: '8px 12px', background: '#f8fafc', borderRadius: '8px', border: '1px solid #e2e8f0' }}>
  <small style={{ color: '#64748b', fontSize: '11px', textTransform: 'uppercase' }}>Selected Candidate</small>
  <div style={{ fontSize: '14px', fontWeight: '700', color: '#334155' }}>
    {selectedStudent?.name} ({selectedStudent?.adm_number})
  </div>
  {/* <div style={{ fontSize: '12px', color: '#e30504', fontWeight: '600', marginTop: '2px' }}>
    {Number(selectedStudent?.total_agreed_fees) === 0 ? (
      <span style={{ color: '#d97706' }}>Initial Deposit / Registration Payment</span>
    ) : (
      `Remaining Outstanding Fees Due: ₹${Number(selectedStudent?.pending_balance_due).toLocaleString('en-IN')}`
    )}
  </div> */}
</div>

        {/* 1. COURSE SELECTION */}
<div style={styles.fieldContainer}>
  <label style={styles.fieldLabel}>Select Enrolled Course</label>
  <select 
    value={paymentForm.target_course} 
    onChange={(e) => handleCourseChangeInModal(e.target.value)} 
    style={styles.formSelect}
  >
    {selectedStudent?.target_course?.split(',').map((cStr, idx) => (
      <option key={idx} value={cStr.trim()}>{cStr.trim()}</option>
    ))}
  </select>
</div>


    

{(() => {
  const courseInfo = getSelectedCourseInfo(paymentForm.target_course);
  const isNonSemester = courseInfo?.structure_type === 'Non-Semester';

  const availableTerms = courseInfo?.semester_details?.length > 0 
    ? courseInfo.semester_details.map(d => d.term_label)
    : (isNonSemester 
        ? Array.from({ length: courseInfo?.minimum_duration || 1 }, (_, i) => `Year ${i + 1}`)
        : Array.from({ length: (courseInfo?.minimum_duration || 3) * 2 }, (_, i) => `Semester ${i + 1}`)
      );

  return (
    <div style={styles.formSplitGrid}>
      {/* Fee Category Type */}
      <div style={styles.fieldContainer}>
        <label style={styles.fieldLabel}>Fee Category Type</label>
        <select 
          value={paymentForm.fee_type} 
          onChange={(e) => {
            const newType = e.target.value;
            setPaymentForm(prev => ({
              ...prev,
              fee_type: newType,
              academic_term: availableTerms[0] || (isNonSemester ? 'Year 1' : 'Semester 1')
            }));
          }} 
          style={styles.formSelect}
        >
          {isNonSemester ? (
            <>
              <option value="Yearly Fee">Yearly Tuition Fee</option>
              <option value="Exam Fee">Yearly Exam Fee</option>
              <option value="Practical Fee">Practical Fee</option>
              <option value="Project Fee">Project Fee</option>
              <option value="Arrear Fee">Arrear Exam Fee</option>
              <option value="Admission Deposit">Admission Deposit</option>
            </>
          ) : (
            <>
              <option value="Semester Fee">Semester Tuition Fee</option>
              <option value="Exam Fee">Semester Exam Fee</option>
              <option value="Practical Fee">Practical Fee</option>
              <option value="Project Fee">Project Fee</option>
              <option value="Arrear Fee">Arrear Exam Fee</option>
              <option value="Admission Deposit">Admission Deposit</option>
            </>
          )}
        </select>
      </div>

      {/* Academic Term Selector */}
      <div style={styles.fieldContainer}>
        <label style={styles.fieldLabel}>
          {isNonSemester ? 'Academic Year / Term' : 'Academic Term / Semester'}
        </label>
        <select 
          value={paymentForm.academic_term} 
          onChange={(e) => setPaymentForm({ ...paymentForm, academic_term: e.target.value })} 
          style={styles.formSelect}
        >
          {paymentForm.fee_type === 'Admission Deposit' ? (
            <option value="Admission Deposit">Admission Deposit</option>
          ) : (
            availableTerms.map((term, idx) => (
              <option key={idx} value={term}>
                {term} ({paymentForm.fee_type})
              </option>
            ))
          )}
        </select>
      </div>
    </div>
  );
})()}

        {/* 3. AMOUNT & PAYMENT MODE */}
        <div style={styles.formSplitGrid}>
          {/* Replace the current Amount Paid input JSX block with this: */}
<div style={styles.fieldContainer}>
  <label style={styles.fieldLabel}>Amount Paid Now (₹)</label>
 <input 
    type="number" 
    required 
    min="1" 
    placeholder="Enter paid amount" 
    value={paymentForm.amount_paid_now} 
    onChange={(e) => setPaymentForm({ ...paymentForm, amount_paid_now: e.target.value })} 
    style={styles.formInput} 
  />
</div>

          <div style={styles.fieldContainer}>
            <label style={styles.fieldLabel}>Payment Collection Mode</label>
            <select 
              value={paymentForm.payment_mode} 
              onChange={(e) => setPaymentForm({ ...paymentForm, payment_mode: e.target.value })} 
              style={styles.formSelect}
            >
              <option>Online Transfer</option>
              <option>Cash Desk Counter</option>
            </select>
          </div>
        </div>

        {/* 4. TRANSACTION REFERENCE */}
        <div style={styles.fieldContainer}>
          <label style={styles.fieldLabel}>Transaction Reference / UTR Number</label>
          <input 
            type="text" 
            required 
            placeholder="e.g. UTR Hash or Voucher ID" 
            value={paymentForm.transaction_reference} 
            onChange={(e) => setPaymentForm({ ...paymentForm, transaction_reference: e.target.value })} 
            style={styles.formInput} 
          />
        </div>

        <div style={styles.formActionDock}>
          <button type="button" onClick={() => setIsCollectModalOpen(false)} style={styles.formCancelBtn}>Cancel</button>
          <button type="submit" style={styles.formSaveBtn}>Confirm & Send Whatsapp</button>
        </div>
      </form>
    </div>
  </div>
)}
      
{/* MODAL 2: HIGH-END PRINTABLE VOUCHER RECEIPT */}
{isPrintModalOpen && (
  <div style={styles.modalBackdrop}>
    <div style={{ ...styles.modalWrapperCard, maxWidth: '680px', background: '#ffffff', padding: '0', borderRadius: '16px', overflow: 'hidden' }}>
      
      {/* Premium Top Bar Window Control */}
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '16px 24px', background: '#0f172a', color: '#ffffff' }}>
        <h3 style={{ margin: 0, fontSize: '14px', fontWeight: '600', letterSpacing: '0.5px' }}>TRANSACTION VOUCHER PREVIEW</h3>
        <button onClick={() => setIsPrintModalOpen(false)} style={styles.modalCloseX}><X size={18} color="#94a3b8" /></button>
      </div>
      
      {/* Scrollable Preview Workspace */}
      <div style={{ overflowY: 'auto', padding: '24px', maxHeight: '65vh', background: '#f8fafc' }}>
        
        {/* START OF LUXURIOUS PRINTABLE RECEIPT CHASSIS */}
        <div id="receipt-print-area" style={styles.receiptChassis}>
          
          {/* Top Brand Identity Header Banner */}
          <div style={styles.receiptHeader}>
            <div style={styles.receiptLogoBox}>Edulearner</div>
            <div style={{ flex: 1 }}>
              <h2 style={styles.receiptInstitutionTitle}>Edulearner OF HIGHER EDUCATION</h2>
              <p style={styles.receiptInstitutionSub}>{selectedReceipt?.college_university || 'Main Campus Center'}</p>
            </div>
            <div style={{ textAlign: 'right' }}>
              <span style={styles.receiptDocumentLabel}>FEE RECEIPT</span>
            </div>
          </div>
{/* Structured Two-Column Metadata Matrix */}
<div style={styles.receiptMetaGrid}>
  <div style={styles.metaColumn}>
    <div style={styles.metaRow}>
      <span style={styles.metaLabel}>Receipt Number</span> 
      <strong style={styles.metaValue}>{selectedReceipt?.receipt_number}</strong>
    </div>
    <div style={styles.metaRow}>
      <span style={styles.metaLabel}>Admission No</span> 
      <strong style={styles.metaValue}>{selectedReceipt?.adm_number}</strong>
    </div>
    <div style={styles.metaRow}>
      <span style={styles.metaLabel}>Student Name</span> 
      <strong style={{ ...styles.metaValue, textTransform: 'uppercase', color: '#0f172a' }}>{selectedReceipt?.name}</strong>
    </div>
  </div>
  <div style={{ ...styles.metaColumn, borderLeft: '1px solid #e2e8f0', paddingLeft: '20px' }}>
    <div style={styles.metaRow}>
      <span style={styles.metaLabel}>Payment Date</span> 
      <strong style={styles.metaValue}>
        {selectedReceipt?.payment_date ? new Date(selectedReceipt.payment_date).toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: 'numeric' }) : 'N/A'}
      </strong>
    </div>
    <div style={styles.metaRow}>
      <span style={styles.metaLabel}>Course Track</span> 
      <strong style={styles.metaValue}>{selectedReceipt?.target_course || 'Academic Program'}</strong>
    </div>
    {/* ➕ Added Fee Category & Term display in metadata */}
    <div style={styles.metaRow}>
      <span style={styles.metaLabel}>Fee Category</span> 
      <strong style={{ ...styles.metaValue, color: '#1c6ec9', fontWeight: '700' }}>
        {selectedReceipt?.fee_type || 'Tuition Fee'} ({selectedReceipt?.academic_term})
      </strong>
    </div>
  </div>
</div>

{/* Minimal Stark Particulars Accounting Ledger Table */}
<table style={styles.receiptTable}>
  <thead>
    <tr>
      <th style={{ ...styles.receiptTh, width: '60px', textAlign: 'center' }}>S.No</th>
      <th style={styles.receiptTh}>Particulars / Fee Breakdown Description</th>
      <th style={{ ...styles.receiptTh, textAlign: 'right', width: '150px' }}>Amount</th>
    </tr>
  </thead>
  <tbody>
    <tr>
      <td style={{ ...styles.receiptTd, textAlign: 'center', color: '#64748b' }}>01</td>
      <td style={styles.receiptTd}>
        {/* ➕ Shows exact Fee Category with Academic Term allocation */}
        <div style={{ fontWeight: '700', color: '#1e293b', fontSize: '13.5px' }}>
          {selectedReceipt?.fee_type || 'Tuition Fee'} – {selectedReceipt?.academic_term} Allocation
        </div>
        <div style={{ fontSize: '11px', color: '#64748b', marginTop: '4px' }}>
          Mode: {selectedReceipt?.payment_mode} | Ref: <span style={{ fontFamily: 'monospace' }}>{selectedReceipt?.transaction_reference || 'N/A'}</span>
        </div>
      </td>
      <td style={{ ...styles.receiptTd, textAlign: 'right', fontWeight: '700', color: '#0f172a', fontSize: '14px' }}>
        ₹{Number(selectedReceipt?.amount_paid_now).toLocaleString('en-IN')}.00
      </td>
    </tr>
    {/* Aesthetic Padding Row */}
    <tr>
      <td style={styles.receiptTdEmpty}></td>
      <td style={styles.receiptTdEmpty}></td>
      <td style={styles.receiptTdEmpty}></td>
    </tr>
    {/* Grand Total Summary Row Block */}
    <tr>
      <td colSpan="2" style={styles.receiptTotalLabelCell}>Total Fees Received</td>
      <td style={styles.receiptTotalValueCell}>
        ₹{Number(selectedReceipt?.amount_paid_now).toLocaleString('en-IN')}.00
      </td>
    </tr>
  </tbody>
</table>

          {/* Validation & Signature Authority Area */}
          <div style={styles.receiptFooterSignatures}>
            <div style={styles.signatureBox}>
              <div style={styles.signatureLine}></div>
              <span>Depositor Signature</span>
            </div>
            <div style={styles.signatureBox}>
              <div style={styles.signatureLine}></div>
              <span>Authorized Officer / Cashier</span>
            </div>
          </div>

          <div style={styles.receiptDisclaimer}>
            This is an official computer-generated statement issued by the Edulearner Finance Portal. Valid without a physical ink stamp.
          </div>

        </div>
        {/* END OF LUXURIOUS PRINTABLE RECEIPT CHASSIS */}

      </div>

      {/* Modal Actions Footer Bar Drawer */}
   {/* Modal Actions Footer Bar Drawer */}
<div style={{ display: 'flex', justifyContent: 'flex-end', gap: '10px', padding: '16px 24px', background: '#ffffff', borderTop: '1px solid #e2e8f0' }}>
  <button onClick={() => setIsPrintModalOpen(false)} style={styles.formCancelBtn}>Close</button>
  
  <button 
    type="button" 
    onClick={() => handleDownloadSingleReceiptPDF(selectedReceipt)}
    style={styles.pdfExportBtn}
  >
    <Download size={14} /> Download Receipt (PDF)
  </button>

  <button 
    onClick={() => {
      const printContent = document.getElementById('receipt-print-area');
      if (!printContent) return;
      
      const printWindow = window.open('', '_blank', 'width=800,height=600');
      printWindow.document.write(`
        <html>
          <head>
            <title>Receipt - ${selectedReceipt?.receipt_number || ''}</title>
            <style>
              body { font-family: system-ui, sans-serif; margin: 20px; }
              table { width: 100%; border-collapse: collapse; }
              th, td { padding: 8px; border-bottom: 1px solid #ddd; }
            </style>
          </head>
          <body>${printContent.innerHTML}</body>
        </html>
      `);
      printWindow.document.close();
      printWindow.focus();
      printWindow.print();
      printWindow.close();
    }} 
    style={styles.receiptPrintSubmitBtn}
  >
    <Printer size={14} /> Print Receipt
  </button>
</div>
    </div>
  </div>
)}
    </div>
  );
}

// FORCE PACKING LUXURIOUS CONTROLS ARCHITECTURE SHEET LAYOUT
const styles = {
  topActionBar: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: '16px', marginBottom: '20px', flexWrap: 'wrap' },
  tabScrollGroup: { display: 'flex', gap: '8px', overflowX: 'auto', paddingBottom: '4px' },
  tabBtn: { display: 'inline-flex', alignItems: 'center', padding: '10px 16px', background: '#ffffff', border: '1px solid #e2e8f0', borderRadius: '10px', color: '#64748b', fontSize: '13.5px', fontWeight: '500', cursor: 'pointer', whiteSpace: 'nowrap', transition: 'all 0.2s' },
  tabBtnActive: { background: 'linear-gradient(135deg, #459bf2 0%, #1c6ec9 100%)', borderColor: '#459bf2', color: '#ffffff', boxShadow: '0 4px 12px rgba(69, 155, 242, 0.15)' },
  filterControlPanel: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: '16px', marginBottom: '16px', flexWrap: 'wrap', borderBottom: '1px solid #edf2f7', paddingBottom: '14px' },
  searchWrapper: { position: 'relative', display: 'flex', alignItems: 'center', flex: 1, maxWidth: '300px', width: '100%' },
  searchIcon: { position: 'absolute', left: '12px', color: '#94a3b8' },
  tableSearchInput: { width: '100%', padding: '9px 12px 9px 36px', background: '#f8fafc', border: '1px solid #e2e8f0', borderRadius: '9px', color: '#0f172a', fontSize: '13.5px', outline: 'none' },
  totalIndicator: { fontSize: '14.5px', fontWeight: '600', color: '#334155' },
  dataTable: { width: '100%', borderCollapse: 'collapse', textAlign: 'left' },
  tableTh: { padding: '12px 14px', borderBottom: '2px solid #e2e8f0', color: '#64748b', fontSize: '11px', textTransform: 'uppercase', letterSpacing: '0.5px', fontWeight: '600', whiteSpace: 'nowrap' },
  tableTr: { borderBottom: '1px solid #f1f5f9', background: '#ffffff' },
  tableTd: { padding: '12px 14px', color: '#475569', fontSize: '13px', verticalAlign: 'middle', whiteSpace: 'nowrap' },
  courseBadge: { background: '#eff6ff', border: '1px solid #bfdbfe', color: '#1e40af', padding: '4px 8px', borderRadius: '6px', fontSize: '11.5px', fontWeight: '500', display: 'inline-block' },
  termLabel: { background: '#f1f5f9', color: '#334155', padding: '4px 6px', borderRadius: '5px', fontSize: '11px', fontWeight: '600', border: '1px solid #e2e8f0' },
  completedTag: { color: '#15803d', background: '#dcfce7', padding: '4px 10px', borderRadius: '6px', fontSize: '12px', fontWeight: '700' },
  collectBtn: { background: '#ffffff', border: '1px solid #cbd5e1', color: '#1c6ec9', padding: '5px 12px', borderRadius: '6px', fontSize: '12px', fontWeight: '700', cursor: 'pointer', transition: 'all 0.2s' },
  printActionBtn: { background: '#f8fafc', border: '1px solid #cbd5e1', color: '#334155', padding: '5px 10px', borderRadius: '6px', fontSize: '12px', fontWeight: '600', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '4px' },
  modalBackdrop: { position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(15, 23, 42, 0.25)', backdropFilter: 'blur(8px)', zIndex: 2000, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '20px' },
  modalWrapperCard: { background: '#ffffff', border: '1px solid rgba(255,255,255,0.8)', borderRadius: '20px', width: '100%', maxWidth: '560px', maxHeight: '85vh', padding: '24px', display: 'flex', flexDirection: 'column', boxSizing: 'border-box', boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.05)' },
  modalHeader: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', paddingBottom: '12px', borderBottom: '1px solid #e2e8f0' },
  modalCloseX: { background: 'transparent', border: 'none', color: '#94a3b8', cursor: 'pointer' },
  modalForm: { display: 'flex', flexDirection: 'column', gap: '14px', marginTop: '14px' },
  formSplitGrid: { display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px' },
  fieldContainer: { display: 'flex', flexDirection: 'column', gap: '4px' },
  fieldLabel: { color: '#64748b', fontSize: '11px', fontWeight: '600', textTransform: 'uppercase', letterSpacing: '0.5px' },
  formInput: { width: '100%', padding: '10px 12px', background: '#f8fafc', border: '1px solid #e2e8f0', borderRadius: '8px', color: '#0f172a', fontSize: '13px', outline: 'none', boxSizing: 'border-box' },
  formSelect: { padding: '10px 12px', background: '#f8fafc', border: '1px solid #e2e8f0', borderRadius: '8px', color: '#0f172a', fontSize: '13px', outline: 'none' },
  formActionDock: { display: 'flex', justifyContent: 'flex-end', gap: '12px', marginTop: '8px', borderTop: '1px solid #e2e8f0', paddingTop: '12px' },
  formCancelBtn: { background: 'transparent', border: '1px solid #e2e8f0', color: '#64748b', padding: '9px 16px', borderRadius: '8px', cursor: 'pointer' },
  excelExportBtn: {
  background: '#ffffff',
  color: '#047857', // Emerald green
  border: '1px solid #a7f3d0',
  padding: '8px 14px',
  borderRadius: '8px',
  fontSize: '12.5px',
  fontWeight: '700',
  cursor: 'pointer',
  display: 'inline-flex',
  alignItems: 'center',
  gap: '6px',
  transition: 'all 0.2s ease',
  boxShadow: '0 1px 2px rgba(0, 0, 0, 0.04)'
},
filterSelectBox: {
  background: '#ffffff',
  border: '1px solid #cbd5e1',
  borderRadius: '8px',
  padding: '6px 10px',
  fontSize: '12.5px',
  color: '#0f172a',
  outline: 'none',
  cursor: 'pointer'
},
resetFilterBtn: {
  background: '#fff1f2',
  border: '1px solid #fecaca',
  color: '#b91c1c',
  padding: '6px 10px',
  borderRadius: '6px',
  fontSize: '11.5px',
  fontWeight: '700',
  cursor: 'pointer'
},
pdfExportBtn: {
  background: '#0f172a', // Dark Navy
  color: '#ffffff',
  border: 'none',
  padding: '8px 15px',
  borderRadius: '8px',
  fontSize: '12.5px',
  fontWeight: '700',
  cursor: 'pointer',
  display: 'inline-flex',
  alignItems: 'center',
  gap: '6px',
  transition: 'all 0.2s ease',
  boxShadow: '0 2px 4px rgba(15, 23, 42, 0.1)'
},
  
  receiptChassis: {
    background: '#ffffff',
    border: '1px solid #e2e8f0',
    borderRadius: '12px',
    padding: '40px',
    boxSizing: 'border-box',
    boxShadow: '0 4px 20px rgba(0, 0, 0, 0.02)'
  },
  receiptHeader: {
    display: 'flex',
    alignItems: 'center',
    gap: '16px',
    borderBottom: '2px solid #1c6ec9', /* Brand Primary Key */
    paddingBottom: '20px',
    marginBottom: '24px'
  },
  receiptLogoBox: {
    background: '#1c6ec9', /* Brand Primary Blue */
    color: '#ffffff',
    fontSize: '22px',
    fontWeight: '800',
    padding: '12px 16px',
    borderRadius: '8px',
    letterSpacing: '0.5px'
  },
  receiptInstitutionTitle: {
    margin: 0,
    fontSize: '18px',
    fontWeight: '800',
    color: '#0f172a',
    letterSpacing: '0.2px'
  },
  receiptInstitutionSub: {
    margin: '3px 0 0 0',
    fontSize: '12.5px',
    color: '#64748b',
    fontWeight: '500'
  },
  receiptDocumentLabel: {
    background: '#fff1f2',
    border: '1px solid #fecaca',
    color: '#a80302', /* Brand Crimson Red Accent */
    padding: '4px 10px',
    borderRadius: '6px',
    fontSize: '11px',
    fontWeight: '700',
    letterSpacing: '0.5px',
    textTransform: 'uppercase'
  },
  receiptMetaGrid: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gap: '20px',
    background: '#f8fafc',
    border: '1px solid #e2e8f0',
    borderRadius: '8px',
    padding: '16px 20px',
    marginBottom: '28px'
  },
  metaColumn: {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px'
  },
  metaRow: {
    display: 'flex',
    alignItems: 'center',
    fontSize: '13px'
  },
  metaLabel: {
    color: '#64748b',
    width: '110px',
    flexShrink: 0
  },
  metaValue: {
    color: '#334155',
    fontWeight: '600'
  },
  receiptTable: {
    width: '100%',
    borderCollapse: 'collapse',
    marginBottom: '40px'
  },
  receiptTh: {
    background: '#f1f5f9',
    borderBottom: '1px solid #cbd5e1',
    padding: '10px 12px',
    fontSize: '11px',
    fontWeight: '700',
    textTransform: 'uppercase',
    color: '#475569',
    letterSpacing: '0.5px'
  },
  receiptTd: {
    borderBottom: '1px solid #e2e8f0',
    padding: '16px 12px',
    fontSize: '13px',
    color: '#334155'
  },
  receiptTdEmpty: {
    borderBottom: '1px solid #e2e8f0',
    padding: '24px 12px'
  },
  receiptTotalLabelCell: {
    padding: '14px 12px',
    fontSize: '13px',
    fontWeight: '700',
    textAlign: 'right',
    color: '#475569'
  },
  receiptTotalValueCell: {
    borderBottom: '2px double #1c6ec9',
    padding: '14px 12px',
    fontSize: '16px',
    fontWeight: '800',
    textAlign: 'right',
    color: '#1c6ec9',
    whiteSpace: 'nowrap'
  },
  receiptFooterSignatures: {
    display: 'flex',
    justifyContent: 'space-between',
    marginTop: '70px',
    padding: '0 16px'
  },
  signatureBox: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    width: '180px',
    fontSize: '11px',
    color: '#64748b',
    fontWeight: '600'
  },
  signatureLine: {
    width: '100%',
    borderBottom: '1px dashed #cbd5e1',
    marginBottom: '6px'
  },
  receiptDisclaimer: {
    textAlign: 'center',
    fontSize: '10px',
    color: '#94a3b8',
    marginTop: '45px',
    borderTop: '1px dashed #e2e8f0',
    paddingTop: '12px'
  },
  receiptPrintSubmitBtn: {
    background: 'linear-gradient(135deg, #459bf2 0%, #1c6ec9 100%)',
    border: 'none',
    color: '#ffffff',
    padding: '9px 20px',
    borderRadius: '8px',
    fontWeight: '600',
    cursor: 'pointer',
    display: 'inline-flex',
    alignItems: 'center',
    gap: '6px',
    boxShadow: '0 4px 12px rgba(28, 110, 201, 0.2)',
    fontSize: '13px'
  },

  // Append these design properties inside your styles object matrix
  paginationDock: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    gap: '12px',
    marginTop: '16px',
    paddingTop: '12px',
    borderTop: '1px solid #edf2f7'
  },
  pageIndicator: {
    fontSize: '13px',
    color: '#475569'
  },
  pageBtn: {
    background: '#ffffff',
    border: '1px solid #e2e8f0',
    borderRadius: '6px',
    padding: '6px 14px',
    color: '#334155',
    fontSize: '12.5px',
    fontWeight: '600',
    cursor: 'pointer',
    transition: 'all 0.2s'
  },
  pageBtnDisabled: {
    background: '#f8fafc',
    color: '#94a3b8',
    cursor: 'not-allowed',
    borderColor: '#e2e8f0'
  },
  formSaveBtn: { background: 'linear-gradient(90deg, #10b981 0%, #059669 100%)', border: 'none', color: '#fff', padding: '9px 16px', borderRadius: '8px', fontWeight: '600', cursor: 'pointer' }
};